// Generated by tools/as3-to-ts from work/decomp/main/scripts/classes/proc.as; hand-edits allowed (see docs/architecture.md)

import { BitmapData, MovieClip, Point, Rectangle } from '@flash';
import * as as3 from '../runtime/as3';
import { HueColorMatrixFilter } from '../com/deviant/HueColorMatrixFilter';

export class proc extends MovieClip {
  FWP: any = undefined;
  GAME_FREEZE: any = false;
  _play_type: any = "";
  _play_id: any = 0;
  call_weapon: any = { "call": false, "id": 0, "range": 1 };
  call_click: any = { "call": false, "x": 0, "y": 0 };
  key_last: any = "";
  key_duration: any = 0;
  key_iter: any = 0;
  PARAMS_RECORD: any = "";
  ROUNDS_RECORD: any = "";
  _initialized: any = false;
  game_control: any = false;
  wpsheet: any = false;
  mousecontrol: any = false;
  choose_worm: any = false;
  choose_worm_id: any = 0;
  choose_worm_timeout: any = 0;
  choose_delay: any = 0;
  choose_worm_fid: any = "";
  strike_dir: any = "from left";
  girder_id: any = 1;
  girder_key_delay: any = 0;
  wait_for_ready: any = 0;
  ai_buttonid: any = "";
  ai_spressed: any = false;
  proc_action: any = { "act": "", "add": 0 };
  proc_timeout: any = 0;
  OBJ: any = new Array<any>(0, {});
  worms: any = new Array<any>(0, {});
  teams: any = new Array<any>(0, {});
  cur_team: any = 0;
  cur_worm: any = 0;
  MEDIUMFLYSPEED: number = 8;
  MINIMUM_SPEED: number = 0.3;
  MAXIMUM_SPEED: number = 40;
  ROTATING_COEF: number = 6;
  FALLING_COEF: number = 0.2;
  FORCESPEED: number = 1.1;
  FORCEMULTIPLIER: number = 0.25;
  WKEYDELAY: number = 2;
  ESCAPETIME: number = 5;
  TURNTIME: number = 45;
  DISPLACE_LIMIT: any = 250;
  G: any = 0.24;
  W: any = 0.1;
  mouse_down: any = false;
  click_coords: any = {};
  call_open_wpsheet: any = false;
  timer: any = 0;
  game_turn: any = 0;
  my_turn: any = 0;
  max_team_hp: any = 0;
  worm_pid_to_die: any = 0;
  displace_seek_type: any = "W";
  displace_seek_obj: any = 1;
  displace_seek_time: any = 0;
  position_x: any = 0;
  position_y: any = 0;
  ai_result: any = {};
  ai_best_result: any = {};
  ai_best_weapon: any = {};
  ai_pos: any = "center";
  ai_target: any = 0;
  ai_weapon: any = 0;
  ai_sleep: any = 0;
  ai_fire_state: any = { "state": "", "timeout": 0 };
  ai_move_dir: any = "";
  ai_move_steps: any = 0;
  ai_move_state: any = 0;
  ai_max_targets: any = 0;
  ai_dest_iters: any = 0;
  ai_dest_time: any = 100;
  ai_trav_time: any = 0;
  ai_virtual_fid: any = "";
  ai_proj_prop: any = { "vx": 0, "vy": 0, "timeout": 0 };
  laser_activated: any = false;
  fire_on_map: any = false;
  ach_last_wptype: any = "";
  ach_killed: any = {
    "p": 0,
    "e": 0,
    "a": 0,
    "c": 0,
    "h": 0,
    "f": 0,
    "l": 0
  };
  ach_paralyzed: any = 0;
  ach_annihilated: any = 0;
  ach_injure: any = false;
  ach_kill: any = false;
  STATUS_TEXT: any = new Array<any>(0, "");
  STATUS_MAX: any = 8;
  REPLAY_PAUSE: any = false;
  worms_init_health: any = new Array();
  mission16_turn: any = 15;
  ag_animation: any = undefined;
  SURV_KILLS: any = 0;
  CUR_STEALTH: any = 0;
  STEALTH_DURATION: any = 0;
  CRATES_ON_MAP: any = 0;
  NORM_filter: any = new HueColorMatrixFilter();
  PI_filter: any = new HueColorMatrixFilter();
  napalm_used: any = false;
  wave_params: any = {};
  // PORT: battle input seam (src/game/runtime/battle-input.ts, design D4). battle_tick counts the ticks of the whole
  // PORT: battle (it advances with `timer`, which restarts at every move); move_starts remembers the first tick and
  // PORT: the team of every move (the per-move origin of the legacy ROUNDS ticks). battle_input is the tick's input
  // PORT: source for every non-replay battle (null: the original direct keyboard reads, the REPLAY mode).
  battle_tick: number = 0;
  move_starts: any = [{ "startTick": 1, "team": 1 }];
  battle_input: any = null;
  // PORT: a battle seed fixed by the backend (battle.start) instead of the local roll (init_gameplay); null = roll.
  battle_seed: any = null;
  // PORT: the seed the battle runs with (cur_random after init_gameplay's roll / override).
  battle_seed_used: any = null;

  constructor(param1: any) {
    super();
    as3.bindMethods(this, proc.prototype);
    this.FWP = param1;
    this.NORM_filter.Hue = 0;
    this.PI_filter.Hue = 200;
  }

  ongoing(): any {
    let _loc2_: any = undefined;
    let _loc1_: any = undefined;
    let _loc3_: any = undefined;
    let _loc4_: any = undefined;
    let _loc5_: any = undefined;
    let _loc6_: any = undefined;
    if (!this._initialized || Boolean(this.GAME_FREEZE)) {
      return;
    }
    if (this.REPLAY_PAUSE) {
      this.check_displace(false, "paused");
      return;
    }
    // PORT: input seam: the tick's input is taken once, before the move logic (the interface acts between ticks).
    const _in: any = this.FWP.REPLAY ? null : this.battle_input;
    if (_in && !_in.begin(this)) {
      return;
    }
    if (this.proc_action.act != "") {
      this.proc_timeout -= this.FWP.FPS;
      if (this.proc_timeout <= 0) {
        if (this.proc_action.act == "first move") {
          this.first_move();
        }
        if (this.proc_action.act == "new move") {
          if (!this.new_move()) {
            return;
          }
        }
        if (this.proc_action.act == "death loop") {
          this.death_loop();
        }
        if (this.proc_action.act == "return wfr") {
          this.FWP._obj[this.OBJ[this.wait_for_ready].fid].states.resting = false;
          this.FWP._proc.OBJ[this.wait_for_ready].ready = false;
          this.wait_for_ready = 0;
          this.proc_action.act = "";
        }
        if (this.proc_action.act == "ai init") {
          this.ai("init");
        }
        if (this.proc_action.act == "ai calc") {
          this.ai("calc");
        }
        if (this.proc_action.act == "ai get next") {
          this.ai("get next");
        }
        if (this.proc_action.act == "ai move init") {
          this.ai("move init");
        }
        if (this.proc_action.act == "ai move") {
          this.ai("move");
        }
        if (this.proc_action.act == "ai find best") {
          this.ai("find best");
        }
        if (this.proc_action.act == "ai move to best") {
          this.ai("move to best");
        }
        if (this.proc_action.act == "ai fire") {
          this.ai("fire");
        }
        if (this.proc_action.act == "ai skip go") {
          this.ai("skip go");
        }
      }
    }
    ++this.timer;
    ++this.battle_tick;
    if (this.timer % 100 == 0) {
      this.check_ready(0);
    }
    // PORT: the open weapon sheet gates the keys only where it freezes the battle (menus_freeze). In an online battle the
    // PORT: ticks run on under it and the seam hands the worms no keys while it is open (BattleInput.begin): the worms
    // PORT: get exactly the recorded frame, as in every other participant's simulation, where no sheet is open.
    _loc2_ = this.game_control && !(this.wpsheet && this.menus_freeze()) && !this.call_weapon.call && !this.call_click.call;
    if (_loc2_) {
      this.write_key_press({ "space": _in ? _in.space : this.FWP.SPACE_PRESSED, "other": _in ? _in.other : this.FWP.KEY_PRESSED });
    } else {
      this.write_key_press({ "space": false, "other": "" });
    }
    if (this.FWP.REPLAY) {
      _loc3_ = this.read_key_press(this.timer);
      _loc4_ = _loc3_.space;
      _loc5_ = _loc3_.other;
      if (_loc5_ == "weapon") {
        this.call_weapon.call = true;
        this.call_weapon.id = _loc3_.weapon;
        this.call_weapon.range = _loc3_.range;
      }
      if (_loc5_ == "click") {
        this.call_click.call = true;
        this.call_click.x = _loc3_.click_x;
        this.call_click.y = _loc3_.click_y;
      }
    }
    if (!this.FWP.REPLAY) {
      _loc1_ = 1;
      while (_loc1_ <= this.OBJ[0]) {
        if (!this.OBJ[_loc1_].free) {
          this.FWP._obj[this.OBJ[_loc1_].fid].ongoing(_loc2_ ? { "space": _in ? _in.space : this.FWP.SPACE_PRESSED, "other": _in ? _in.other : this.FWP.KEY_PRESSED } : {});
        }
        _loc1_++;
      }
    } else {
      _loc1_ = 1;
      while (_loc1_ <= this.OBJ[0]) {
        if (!this.OBJ[_loc1_].free) {
          this.FWP._obj[this.OBJ[_loc1_].fid].ongoing(_loc2_ ? { "space": _loc4_, "other": _loc5_ } : {});
        }
        _loc1_++;
      }
    }
    // PORT: the timer and the status line are the battle screen's (game_link): in an online battle the scanner may lie
    // PORT: on top of it while the ticks run. PORT: an online battle's clock runs under the weapon sheet (menus_freeze):
    // PORT: its timer too, the same seconds as the touch controls' clock over the sheet.
    if (!this.wpsheet || !this.menus_freeze()) {
      if (this.cur_worm != 0 && this.worms[this.cur_worm].state != "none" && this.FWP._obj[this.worms[this.cur_worm].fid].vars.timeout != -100) {
        this.game_link().timer.text = String(Math.ceil(this.FWP._obj[this.worms[this.cur_worm].fid].vars.timeout / 1000));
      } else {
        this.game_link().timer.text = "0";
      }
    }
    if (this.choose_worm) {
      this.game_link().timer.text = String(Math.ceil(this.choose_worm_timeout / 1000));
    }
    this.check_displace(false);
    if (this.call_open_wpsheet) {
      this.open_wpsheet();
    }
    if (this.mousecontrol) {
      this.check_mousecontrol();
    }
    if (this.choose_worm) {
      this.choosing_worm();
    }
    if (this.call_weapon.call) {
      this.FWP._obj[this.worms[this.cur_worm].fid].weapon.set_w = this.call_weapon.id;
      this.FWP._obj[this.worms[this.cur_worm].fid].weapon.set_w_range = this.call_weapon.range;
      this.call_weapon.call = false;
      this.write_key_press({ "space": false, "other": "weapon" });
    }
    if (this.call_click.call) {
      this.proceed_mousecontrol();
      this.call_click.call = false;
      this.write_key_press({ "space": false, "other": "click" });
    }
    if (this.cur_worm != 0) {
      if (Boolean(this.game_control) && this.worms[this.cur_worm].state == "ok") {
        _loc6_ = this.FWP._obj[this.worms[this.cur_worm].fid];
        if (Boolean(_loc6_.states.firecontrol && _loc6_.states.flying == 0 && !_loc6_.ai) && Boolean(_loc6_.weapon.shots_total == 0) && _loc6_.states.special == "") {
          if (this.FWP.QUICK_WEAPON_PRESSED == "q" && !this.wpsheet) {
            this.open_wpsheet();
          }
        }
      }
    }
    if (_in) {
      _in.end(this, _loc2_);
    }
  }

  init_gameplay(param1: any, param2: any, param3: any, param4: number): any {
    param3 = as3.str(param3);
    param4 = Number(param4);
    let _loc5_: any = undefined;
    let _loc6_: any = undefined;
    let _loc7_: any = undefined;
    let _loc8_: any = undefined;
    let _loc9_: any = undefined;
    let _loc10_: any = undefined;
    let _loc11_: any = undefined;
    let _loc12_: any = undefined;
    let _loc13_: any = undefined;
    let _loc14_: any = undefined;
    let _loc15_: any = undefined;
    let _loc16_: any = undefined;
    let _loc17_: any = undefined;
    let _loc18_: any = undefined;
    let _loc19_: any = undefined;
    this._play_type = param3;
    this._play_id = param4;
    this.ag_animation = this.FWP.container_proc.get_object("ag_all");
    this.FWP.display_obj.addChild(this.ag_animation);
    this.ag_animation.visible = false;
    if (this.FWP.player.settings.skill >= 10 && this._play_type != "assault" && this._play_type != "just") {
      this.TURNTIME = 20;
    } else {
      this.TURNTIME = 45;
    }
    if (!this.FWP.REPLAY) {
      this.append_replay_param("play_type", param3);
    }
    if (!this.FWP.REPLAY) {
      this.append_replay_param("play_id", param4);
    }
    this.choose_worm_fid = "obj" + this.make_object("E", "choose_worm", "", { "x": 10, "y": 10, "ethernal": true });
    this.FWP._obj[this.choose_worm_fid].visible = false;
    this.FWP.cur_random = this.FWP.true_random(0, 399);
    // PORT: the backend's battle seed replaces the roll (still drawn: the non-gameplay random sequence is unchanged).
    if (this.battle_seed != null && !this.FWP.REPLAY) {
      this.FWP.cur_random = Number(this.battle_seed);
    }
    _loc5_ = 0;
    if (this.FWP.REPLAY) {
      this.FWP.cur_random = this.FWP.replay_cur_random;
    }
    this.battle_seed_used = this.FWP.cur_random;
    if (!this.FWP.REPLAY) {
      this.append_replay_param("random", this.FWP.cur_random);
    }
    _loc6_ = this.FWP._world.get_coord_shift();
    _loc7_ = _loc6_ + this.FWP.cur_random % 100;
    if (param3 != "just") {
      ++param2.teams;
      param2.team1 = param1;
      _loc9_ = 0;
      if (this.FWP.player.perks["fast_walk"]) {
        _loc9_ = this.FWP.player.perks.fast_walk;
      }
      if (_loc9_ > 0 && _loc9_ < 3) {
        param2.team1.weapons["fast_walk"] = [0, Math.min(param2.team1.weapons["fast_walk"][1] + _loc9_, 10), 0, 0, 0, 0, 0, 0, 0, 0, 0];
      }
      _loc10_ = 0;
      if (this.FWP.player.perks["morale"]) {
        _loc10_ = this.FWP.player.perks.morale;
      }
      if (_loc10_ > 0 && _loc10_ < 3) {
        param2.team1.weapons["choose_worm"] = [0, Math.min(param2.team1.weapons["choose_worm"][1] + _loc10_, 3), 0, 0, 0, 0, 0, 0, 0, 0, 0];
      }
      if (_loc10_ == 3) {
        param2.team1.weapons["choose_worm"] = [0, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      }
      _loc11_ = 0;
      if (this.FWP.player.perks["pe"]) {
        _loc11_ = this.FWP.player.perks.pe;
      }
      if (_loc11_ == 3) {
        param2.team1.weapons["ultra_scaner"] = [0, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      }
      if (!this.FWP.REPLAY) {
        this.append_replay_param("player", param1);
      }
    }
    _loc8_ = 1;
    while (_loc8_ <= param2.teams) {
      ++this.teams[0];
      this.teams[this.teams[0]] = {
        "state": "ok",
        "worms": param2["team" + _loc8_].worms,
        "color": param2["team" + _loc8_].color,
        "weapons": {},
        "name": param2["team" + _loc8_].name,
        "cpu_level": param2["team" + _loc8_].cpu_level,
        "last_worm": 0,
        "turns": 0
      };
      if (this._play_type == "missions" && this._play_id == 16 && _loc8_ == 1) {
        this.teams[this.teams[0]].weapons["skip_go"] = [0, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      } else {
        for (_loc12_ of as3.keys(param2["team" + _loc8_].weapons)) {
          this.teams[this.teams[0]].weapons[_loc12_] = this.FWP.clone(param2["team" + _loc8_].weapons[_loc12_]);
        }
      }
      if (this._play_type == "just") {
        for (_loc12_ of as3.keys(this.FWP.GUM_DEF)) {
          this.teams[this.teams[0]].weapons[_loc12_] = [0, this.FWP.GUM_DEF[_loc12_], 0, 0, 0, 0, 0, 0, 0, 0];
        }
      }
      if (this._play_type != "just" && _loc8_ == 1) {
        if (this._play_type == "career" || this._play_type == "survival" || this._play_type == "boss" || this._play_type == "assault") {
          _loc15_ = this.FWP.GUM_DEF;
        }
        if (this._play_type == "missions") {
          _loc15_ = this.FWP.MISSION_WEAP_DEF[this.FWP._world.chosen_map];
        }
        for (_loc12_ of as3.keys(_loc15_)) {
          if (!this.teams[this.teams[0]].weapons[_loc12_]) {
            this.teams[this.teams[0]].weapons[_loc12_] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
          }
          if (_loc15_[_loc12_] == 100) {
            this.teams[this.teams[0]].weapons[_loc12_][1] = 100;
          } else {
            this.teams[this.teams[0]].weapons[_loc12_][1] = Math.min(10, this.teams[this.teams[0]].weapons[_loc12_][1] + _loc15_[_loc12_]);
          }
        }
      }
      _loc13_ = 0;
      _loc14_ = 1;
      while (_loc14_ <= param2["team" + _loc8_].worms) {
        if (this._play_type == "missions") {
          _loc16_ = this.FWP._world.WORM_MISSION_COORDS[this.FWP._world.chosen_map]["team" + _loc8_][_loc5_];
          _loc17_ = this.FWP._world.WORM_MISSION_COORDS[this.FWP._world.chosen_map]["team" + _loc8_][_loc5_ + 1];
        } else if (this._play_type == "boss") {
          _loc16_ = this.FWP._world.WORM_BOSS_COORDS["boss" + this._play_id]["team" + _loc8_][_loc5_];
          _loc17_ = this.FWP._world.WORM_BOSS_COORDS["boss" + this._play_id]["team" + _loc8_][_loc5_ + 1];
          if (_loc8_ == 2) {
            this.ag_animation.x = _loc16_;
            this.ag_animation.y = _loc17_;
            this.ag_animation.visible = true;
          }
        } else if (this._play_type == "assault") {
          _loc16_ = this.FWP._world.WORM_ASSAULT_COORDS["assault" + this._play_id]["team" + _loc8_][_loc5_];
          _loc17_ = this.FWP._world.WORM_ASSAULT_COORDS["assault" + this._play_id]["team" + _loc8_][_loc5_ + 1];
          if (_loc8_ == 2) {
            this.ag_animation.x = _loc16_;
            this.ag_animation.y = _loc17_;
            this.ag_animation.visible = true;
          }
        } else {
          _loc16_ = this.FWP._world.WORM_COORDS[_loc7_][_loc5_];
          _loc17_ = this.FWP._world.WORM_COORDS[_loc7_][_loc5_ + 1];
        }
        _loc18_ = this.make_object("W", "worm", "", { "x": _loc16_, "y": _loc17_ });
        ++this.worms[0];
        this.worms[this.worms[0]] = { "state": "ok", "fid": "obj" + _loc18_ };
        _loc5_ += 2;
        this.FWP._obj["obj" + _loc18_].wid = this.worms[0];
        this.FWP._obj["obj" + _loc18_].skills = {
          "attack": param2["team" + _loc8_]["worm" + _loc14_].attack,
          "protect": param2["team" + _loc8_]["worm" + _loc14_].protect,
          "spec": param2["team" + _loc8_]["worm" + _loc14_].spec
        };
        this.FWP._obj["obj" + _loc18_].vars.health = param2["team" + _loc8_]["worm" + _loc14_].health;
        if (_loc8_ == 1 && Boolean(this.FWP.player.perks["medic"])) {
          this.FWP._obj["obj" + _loc18_].vars.health = Math.ceil(this.FWP._obj["obj" + _loc18_].vars.health * this.FWP.get_perk_effect("medic", this.FWP.player.perks.medic, ""));
        }
        if (_loc8_ == 1 && _loc14_ == 1 && Boolean(this.FWP.player.perks["comandeer"])) {
          this.FWP._obj["obj" + _loc18_].vars.health += this.FWP.get_perk_effect("comandeer", this.FWP.player.perks.comandeer, "");
        }
        if (_loc8_ != 1 && this._play_type != "just") {
          if (this._play_type != "assault") {
            this.FWP._obj["obj" + _loc18_].skills.attack += this.FWP.get_skill_multi("attack");
            this.FWP._obj["obj" + _loc18_].skills.protect += this.FWP.get_skill_multi("protect");
            this.FWP._obj["obj" + _loc18_].vars.health = Math.ceil(this.FWP._obj["obj" + _loc18_].vars.health * this.FWP.get_skill_multi("health"));
          } else {
            this.FWP._obj["obj" + _loc18_].skills.attack = this.FWP.get_assault_multi("attack", this.FWP._obj["obj" + _loc18_].skills.attack, this.FWP._play_zone_stage, this._play_id);
            this.FWP._obj["obj" + _loc18_].skills.protect = this.FWP.get_assault_multi("protect", this.FWP._obj["obj" + _loc18_].skills.protect, this.FWP._play_zone_stage, this._play_id);
            this.FWP._obj["obj" + _loc18_].vars.health = this.FWP.get_assault_multi("health", this.FWP._obj["obj" + _loc18_].vars.health, this.FWP._play_zone_stage, this._play_id);
          }
        }
        this.FWP._obj["obj" + _loc18_].wteam = _loc8_;
        this.FWP._obj["obj" + _loc18_].wcolor = param2["team" + _loc8_].color;
        this.FWP._obj["obj" + _loc18_].ai = param2["team" + _loc8_].cpu_level > 0;
        if (_loc8_ == 1) {
          this.FWP._obj["obj" + _loc18_].wname = this.FWP.get_player_worm_name(_loc14_, this._play_type);
        } else {
          this.FWP._obj["obj" + _loc18_].wname = param2["team" + _loc8_]["worm" + _loc14_].name;
        }
        this.FWP._obj["obj" + _loc18_].worm_modify_bars();
        this.FWP._obj["obj" + _loc18_].worm_modify_bar_borders("");
        for (_loc19_ of as3.keys(param2["team" + _loc8_]["worm" + _loc14_].perks)) {
          this.FWP._obj["obj" + _loc18_].perks[_loc19_] = param2["team" + _loc8_]["worm" + _loc14_].perks[_loc19_];
        }
        this.FWP._obj["obj" + _loc18_].worm_modify_sprite("animate");
        _loc13_ += param2["team" + _loc8_]["worm" + _loc14_].health;
        this.worms_init_health[this.worms[0]] = param2["team" + _loc8_]["worm" + _loc14_].health;
        _loc14_++;
      }
      if (this._play_type == "missions" || this._play_type == "boss" || this._play_type == "assault") {
        _loc5_ = 0;
      }
      if (_loc13_ > this.max_team_hp) {
        this.max_team_hp = _loc13_;
      }
      // PORT: an online battle names each team's player (FWP.team_label; display only).
      this.FWP._interf.cur_screen[this.FWP._interf.cur_screen[0]].link["team" + String(_loc8_) + "_name"].text = this.FWP.team_label(_loc8_, param2["team" + _loc8_].name);
      this.FWP._interf.cur_screen[this.FWP._interf.cur_screen[0]].link["team" + String(_loc8_) + "_name"].textColor = this.game_get_color(param2["team" + _loc8_].color);
      _loc8_++;
    }
    this.mission_scripts("init");
    this._initialized = true;
    this.game_control = true;
    this.FWP.stage_focus();
    this.FWP._interf.render_game_menu();
    if (this.FWP.REPLAY) {
      this.FWP.decode_move(1);
    }
    this.proc_action.act = "first move";
    this.proc_timeout = 500;
    this.game_displace(0, 0);
  }

  make_object(param1: any, param2: any, param3: any, param4: any): number {
    param1 = as3.str(param1);
    param2 = as3.str(param2);
    param3 = as3.str(param3);
    let _loc5_: any = this.FWP.add_obj(param1, param2, param3, param4);
    ++this.OBJ[0];
    this.OBJ[this.OBJ[0]] = { "fid": "obj" + _loc5_, "model": param1, "free": false, "ready": false };
    if (param1 == "W" || param4.ethernal == true || param4.already_ready == true) {
      this.OBJ[this.OBJ[0]].ready = true;
    }
    this.FWP._obj["obj" + _loc5_].pid = this.OBJ[0];
    return Number(_loc5_);
  }

  remove_object(param1: any, param2: number, param3: boolean): any {
    param2 = Number(param2);
    param3 = Boolean(param3);
    let _loc4_: any = Number(String(this.OBJ[param2].fid).split("obj")[1]);
    if (this.FWP._interf.distance_boxes["box" + _loc4_]) {
      this.FWP._interf.distance_box_container.removeChild(this.FWP._interf.distance_boxes["box" + _loc4_]);
      this.FWP._interf.distance_boxes["box" + _loc4_] = null;
      delete this.FWP._interf.distance_boxes["box" + _loc4_];
    }
    this.OBJ[param2].free = true;
    this.FWP.remove_obj(param1);
    delete this.FWP._obj[this.OBJ[param2].fid];
    if (param3) {
      this.check_ready(param2);
    }
  }

  first_move(): any {
    let _loc2_: any = undefined;
    let _loc3_: any = undefined;
    let _loc1_: any = undefined;
    this.proc_action.act = "";
    this.cur_worm = 1;
    this.cur_team = 1;
    this.teams[this.cur_team].last_worm = this.cur_worm;
    _loc1_ = this.FWP._obj[this.worms[this.cur_worm].fid];
    _loc1_.states.resting = false;
    _loc1_.states.active = true;
    _loc2_ = 0;
    if (Boolean(this.FWP.player.perks["thinker"]) && this.cur_team == 1) {
      _loc2_ = this.FWP.get_perk_effect("thinker", this.FWP.player.perks.thinker, "");
    }
    if (this.FWP.player.spec == 2 && this.cur_team == 1) {
      _loc2_ = this.FWP.get_perk_effect("thinker", 3, "");
    }
    _loc1_.vars.timeout = (this.TURNTIME + _loc2_) * 1000;
    this.OBJ[_loc1_.pid].ready = false;
    this.generate_wind();
    _loc3_ = 0;
    if (this.FWP.player.perks["fast_walk"]) {
      _loc3_ = this.FWP.player.perks.fast_walk;
    }
    if ((_loc3_ == 3 || this.FWP.player.spec == 1) && this.cur_team == 1) {
      this.WKEYDELAY = 1;
    }
    this.apply_worms_alpha();
    this.add_status("Ход #1... Ходит: " + this.FWP.team_label(this.cur_team, this.teams[this.cur_team].name));
    // PORT (touch screens): the camera placed for the first worm as for every later one (new_move), so that the touch
    // controls' clusters do not cover it (FWP.camera_margin); the original's first view stays elsewhere. Presentation.
    const _cm: any = this.FWP.camera_margin();
    if (_cm.keep_left > 0 || _cm.keep_right > 0) {
      this.check_displace(true);
      this.frame_worms();
    }
  }

  new_move(): boolean {
    let _loc2_: any = undefined;
    let _loc3_: any = undefined;
    let _loc4_: any = undefined;
    let _loc5_: any = undefined;
    let _loc6_: any = undefined;
    let _loc7_: any = undefined;
    let _loc8_: any = undefined;
    let _loc9_: any = undefined;
    let _loc1_: any = undefined;
    let _loc10_: any = undefined;
    let _loc11_: any = undefined;
    let _loc12_: any = undefined;
    let _loc13_: any = undefined;
    this.proc_action.act = "";
    _loc2_ = 0;
    _loc3_ = new Array<any>(false, false, false, false, false, false, false, false);
    _loc4_ = 0;
    _loc5_ = 1;
    while (_loc5_ <= this.teams[0]) {
      if (this.teams[_loc5_].state == "ok") {
        _loc2_++;
        _loc3_[this.teams[_loc5_].color] = true;
      }
      _loc5_++;
    }
    _loc5_ = 1;
    while (_loc5_ <= 7) {
      if (_loc3_[_loc5_]) {
        _loc4_++;
      }
      _loc5_++;
    }
    if (_loc2_ < 2 || _loc4_ < 2) {
      _loc10_ = 0;
      _loc5_ = 1;
      while (_loc5_ <= this.teams[0]) {
        if (this.teams[_loc5_].state == "ok") {
          _loc10_ = _loc5_;
          break;
        }
        _loc5_++;
      }
      this.FWP.end_game_fn(_loc10_);
      return false;
    }
    if (!this.mission_scripts("check")) {
      this.FWP.end_game_fn(0);
      return false;
    }
    _loc6_ = 0;
    do {
      ++this.cur_team;
      if (this.cur_team > this.teams[0]) {
        this.cur_team = 1;
      }
    } while (this.teams[this.cur_team].state != "ok");
    _loc7_ = this.teams[this.cur_team].last_worm;
    do {
      if (++_loc7_ > this.worms[0]) {
        _loc7_ = 1;
      }
      if (this.worms[_loc7_].state == "ok" && this.FWP._obj[this.worms[_loc7_].fid].wteam == this.cur_team) {
        this.cur_worm = _loc7_;
        this.teams[this.cur_team].last_worm = this.cur_worm;
        break;
      }
    } while (++_loc6_ <= 100);
    _loc5_ = 1;
    while (_loc5_ <= this.worms[0]) {
      if (this.worms[_loc5_].state == "ok") {
        this.FWP._obj[this.worms[_loc5_].fid].states.escape = false;
        this.FWP._obj[this.worms[_loc5_].fid].weapon_id = 0;
        this.FWP._obj[this.worms[_loc5_].fid].weapon_range = 1;
        this.FWP._obj[this.worms[_loc5_].fid].weapon.shots_remain = 0;
        this.FWP._obj[this.worms[_loc5_].fid].weapon.shots_total = 0;
        this.FWP._obj[this.worms[_loc5_].fid].dmg_mult = 1;
        if (this.FWP._obj[this.worms[_loc5_].fid].wteam == this.cur_team && Boolean(this.FWP._obj[this.worms[_loc5_].fid].vars.paralyzed)) {
          --this.FWP._obj[this.worms[_loc5_].fid].vars.paratime;
          if (this.FWP._obj[this.worms[_loc5_].fid].vars.paratime == 0) {
            this.FWP._obj[this.worms[_loc5_].fid].vars.paralyzed = false;
          }
        }
        if (this.FWP._obj[this.worms[_loc5_].fid].sick_next != 0 || Boolean(this.FWP._obj[this.worms[_loc5_].fid].sick)) {
          this.FWP._obj[this.worms[_loc5_].fid].sick += this.FWP._obj[this.worms[_loc5_].fid].sick_next;
          this.FWP._obj[this.worms[_loc5_].fid].sick_next = 0;
          if (this.FWP._obj[this.worms[_loc5_].fid].vars.health > this.FWP._obj[this.worms[_loc5_].fid].sick) {
            this.FWP._obj[this.worms[_loc5_].fid].worm_apply_damage(this.FWP._obj[this.worms[_loc5_].fid].sick, "poison");
          } else {
            this.FWP._obj[this.worms[_loc5_].fid].worm_apply_damage(this.FWP._obj[this.worms[_loc5_].fid].vars.health - 1, "poison");
          }
        }
        if (Boolean(this.FWP._obj[this.worms[_loc5_].fid].perks["regeneration"] && this.FWP._obj[this.worms[_loc5_].fid].perks["regeneration"] != 0) && Boolean(this.cur_team == this.FWP._obj[this.worms[_loc5_].fid].wteam) && this.FWP._obj[this.worms[_loc5_].fid].vars.health < this.worms_init_health[_loc5_]) {
          _loc11_ = this.FWP.get_perk_effect("regeneration", this.FWP._obj[this.worms[_loc5_].fid].perks["regeneration"], "");
          _loc12_ = 0;
          if (this.FWP._obj[this.worms[_loc5_].fid].vars.health + _loc11_ > this.worms_init_health[_loc5_]) {
            _loc12_ = this.worms_init_health[_loc5_] - this.FWP._obj[this.worms[_loc5_].fid].vars.health;
          } else {
            _loc12_ = _loc11_;
          }
          this.FWP._obj[this.worms[_loc5_].fid].worm_apply_damage(-_loc12_, "regen");
        }
      }
      _loc5_++;
    }
    if (this.wpsheet) {
      this.close_wpsheet(0);
    }
    if (this.mousecontrol) {
      this.remove_mousecontrol();
    }
    _loc1_ = this.FWP._obj[this.worms[this.cur_worm].fid];
    if (this.cur_team == 1) {
      ++this.my_turn;
    }
    ++this.game_turn;
    this.timer = 0;
    this.G = 0.24;
    this.WKEYDELAY = 2;
    this.laser_activated = false;
    this.napalm_used = false;
    _loc8_ = 0;
    if (this.FWP.player.perks["fast_walk"]) {
      _loc8_ = this.FWP.player.perks.fast_walk;
    }
    if (_loc8_ == 3 && this.cur_team == 1) {
      this.WKEYDELAY = 1;
    }
    this.generate_wind();
    this.add_status("-----------------------------------------");
    this.add_status("Ход #" + (this.game_turn + 1) + "... Ходит: " + this.FWP.team_label(this.cur_team, this.teams[this.cur_team].name));
    this.OBJ[_loc1_.pid].ready = false;
    _loc1_.vars.damage = false;
    _loc1_.states.resting = false;
    _loc1_.states.active = true;
    _loc9_ = 0;
    if (Boolean(this.FWP.player.perks["thinker"]) && this.cur_team == 1) {
      _loc9_ = this.FWP.get_perk_effect("thinker", this.FWP.player.perks.thinker, "");
    }
    if (this.FWP.player.spec == 2 && this.cur_team == 1) {
      _loc9_ = this.FWP.get_perk_effect("thinker", 3, "");
    }
    _loc1_.vars.timeout = (this.TURNTIME + _loc9_) * 1000;
    _loc1_.states.control = true;
    _loc1_.states.firecontrol = true;
    _loc1_.states.escape = false;
    this.check_displace(true);
    this.FWP.stage_focus();
    if (this.teams[this.cur_team].cpu_level != 0) {
      this.proc_action.act = "ai init";
      this.proc_timeout = 1000;
    }
    this.game_control = this.teams[this.cur_team].cpu_level == 0;
    if (this.cur_team == 1) {
      this.ROUNDS_RECORD += "#";
      if (this.FWP.REPLAY) {
        this.FWP.decode_move(this.my_turn + 1);
      }
    } else if (this.FWP.REPLAY) {
      this.FWP.clear_move();
    }
    if (this._play_type == "missions" && this._play_id == 16) {
      this.mission_scripts("check protect");
    }
    ++this.teams[this.cur_team].turns;
    if (this.CRATES_ON_MAP < 5) {
      _loc13_ = this.FWP.get_crate_param(this.FWP.player.perks, this._play_type, this.FWP.player.spec);
      if (_loc13_.generate) {
        this.generate_crate(this.FWP.pseudo_random(20, this.FWP._world.map_bitmap.width - 20), _loc13_.weapon);
      }
    }
    if (this.cur_team == 1 && this.STEALTH_DURATION != 0) {
      --this.STEALTH_DURATION;
      if (this.STEALTH_DURATION == 0) {
        this.CUR_STEALTH = 0;
      }
      this.apply_worms_alpha();
    }
    // PORT: the move's first tick is the next battle tick (timer restarts at 1 there).
    this.move_starts.push({ "startTick": this.battle_tick + 1, "team": this.cur_team });
    if (this.battle_input && !this.FWP.REPLAY) {
      this.battle_input.new_move(this);
    }
    return true;
  }

  mission_scripts(param1: any): boolean {
    param1 = as3.str(param1);
    let _loc2_: any = undefined;
    let _loc3_: any = undefined;
    let _loc4_: any = undefined;
    let _loc5_: any = undefined;
    let _loc6_: any = undefined;
    let _loc7_: any = undefined;
    let _loc8_: any = undefined;
    let _loc9_: any = undefined;
    let _loc10_: any = undefined;
    if (param1 == "init" && this._play_type == "missions" && this._play_id == 3) {
      this.make_object("D", "drum", "mad_cow", { "x": 661, "y": 505, "already_ready": true });
      this.make_object("D", "drum", "mad_cow", { "x": 723, "y": 498, "already_ready": true });
      this.make_object("D", "drum", "mad_cow", { "x": 792, "y": 498, "already_ready": true });
    }
    if (param1 == "init" && this._play_type == "missions" && this._play_id == 13) {
      this.make_object("D", "drum", "", { "x": 396, "y": 360, "already_ready": true });
      this.make_object("D", "drum", "", { "x": 481, "y": 466, "already_ready": true });
      this.make_object("D", "drum", "", { "x": 568, "y": 466, "already_ready": true });
      this.make_object("D", "drum", "", { "x": 631, "y": 396, "already_ready": true });
    }
    if (param1 == "init" && this._play_type == "missions" && this._play_id == 16) {
      this.FWP.WEAPONS_DEF.pistol.delay = 1;
      this.FWP.WEAPONS_DEF.uzi.delay = 3;
      this.FWP.WEAPONS_DEF.uzi.delay = 4;
      this.FWP.WEAPONS_DEF.banana_bomb.delay = 6;
      this.FWP.WEAPONS_DEF.holy_hand_grenade.delay = 7;
      this.FWP.WEAPONS_DEF.firepunch.delay = 1;
      this.FWP.WEAPONS_DEF.baseball_bat.delay = 4;
      this.FWP.WEAPONS_DEF.low_gravity.delay = 2;
      this.FWP.WEAPONS_DEF.jet_pack.delay = 6;
      this.FWP.WEAPONS_DEF.bazooka.delay = 7;
      this.FWP.WEAPONS_DEF.grenade.delay = 8;
      this.FWP.WEAPONS_DEF.laser_rifle.delay = 2;
      this.FWP.WEAPONS_DEF.plasma_pistol.delay = 5;
      this.FWP.WEAPONS_DEF.gauss_pistol.delay = 9;
      this.FWP.WEAPONS_DEF.teleport.delay = 9;
    }
    if (param1 == "check" && this._play_type == "missions" && this._play_id == 3) {
      _loc3_ = 0;
      for (_loc4_ of as3.keys(this.FWP._obj)) {
        if (this.FWP._obj[_loc4_].model == "D") {
          _loc3_++;
        }
      }
      if (_loc3_ == 0) {
        return false;
      }
    }
    if (param1 == "check" && this._play_type == "missions" && this._play_id == 4) {
      _loc5_ = 0;
      _loc2_ = 1;
      while (_loc2_ <= this.worms[0]) {
        if (this.worms[_loc2_].state == "ok") {
          if (this.FWP._obj[this.worms[_loc2_].fid].wteam == 2) {
            _loc5_++;
          }
        }
        _loc2_++;
      }
      if (_loc5_ == 0) {
        return false;
      }
    }
    if (param1 == "init" && this._play_type == "missions" && this._play_id >= 7 && this._play_id <= 10) {
      for (_loc6_ of as3.keys(this.FWP.WEAPONS_DEF)) {
        if (this.FWP.WEAPONS_DEF[_loc6_].wptype == "a") {
          this.FWP.WEAPONS_DEF[_loc6_].delay = Number.POSITIVE_INFINITY;
        }
      }
    }
    if (param1 == "check" && this._play_type == "missions" && this._play_id == 8) {
      _loc2_ = 1;
      while (_loc2_ <= this.worms[0]) {
        if (this.worms[_loc2_].state == "ok") {
          if (this.FWP._obj[this.worms[_loc2_].fid].wteam == 3) {
            this.FWP._obj[this.worms[_loc2_].fid].worm_apply_damage(-2, "regen");
          }
        }
        _loc2_++;
      }
    }
    if (param1 == "check" && this._play_type == "missions" && this._play_id == 9) {
      _loc2_ = 1;
      while (_loc2_ <= this.worms[0]) {
        if (this.worms[_loc2_].state == "ok") {
          if (this.FWP._obj[this.worms[_loc2_].fid].wteam == 2) {
            this.FWP._obj[this.worms[_loc2_].fid].worm_apply_damage(-4, "regen");
          }
        }
        _loc2_++;
      }
    }
    if (param1 == "check" && this._play_type == "missions" && this._play_id == 10) {
      _loc2_ = 1;
      while (_loc2_ <= this.worms[0]) {
        if (this.worms[_loc2_].state == "ok") {
          if (this.FWP._obj[this.worms[_loc2_].fid].wteam == 2) {
            this.FWP._obj[this.worms[_loc2_].fid].worm_apply_damage(-10, "regen");
          }
        }
        _loc2_++;
      }
      _loc2_ = 1;
      while (_loc2_ <= this.worms[0]) {
        if (this.worms[_loc2_].state == "ok") {
          if (this.FWP._obj[this.worms[_loc2_].fid].wteam == 3) {
            this.FWP._obj[this.worms[_loc2_].fid].worm_apply_damage(-5, "regen");
          }
        }
        _loc2_++;
      }
    }
    if (param1 == "check" && this._play_type == "missions" && this._play_id == 13) {
      _loc7_ = 0;
      for (_loc8_ of as3.keys(this.FWP._obj)) {
        if (this.FWP._obj[_loc8_].model == "D") {
          _loc7_++;
        }
      }
      if (_loc7_ < 2) {
        return false;
      }
    }
    if (param1 == "check" && this._play_type == "missions" && this._play_id == 15) {
      if (this.cur_team == 1) {
        _loc9_ = 10 - this.my_turn;
        this.FWP._proc.add_status("Осталось " + _loc9_ + " ход" + (_loc9_ == 1 ? "" : (_loc9_ < 5 ? "а" : "ов")) + ".");
      }
      if (this.my_turn >= 10) {
        return false;
      }
    }
    if (param1 == "check protect" && this._play_type == "missions" && this._play_id == 16) {
      if (this.my_turn < this.mission16_turn && this.cur_team == 1) {
        _loc10_ = this.mission16_turn - this.my_turn;
        this.FWP._proc.add_status("Бункер откроется через " + _loc10_ + " ход" + (_loc10_ == 1 ? "" : (_loc10_ < 5 ? "а" : "ов")) + ".");
      }
      if (this.my_turn == this.mission16_turn) {
        this.FWP._world.mission_scripts(16);
      }
    }
    return true;
  }

  death_loop(): any {
    let _loc1_: any = undefined;
    this.proc_action.act = "";
    _loc1_ = this.FWP._obj[this.OBJ[this.worm_pid_to_die].fid];
    this.OBJ[this.worm_pid_to_die].ready = false;
    _loc1_.death = true;
    _loc1_.vars.special_timeout = 0;
  }

  choosing_worm(): any {
    let _loc1_: any = undefined;
    let _loc2_: any = undefined;
    let _loc3_: any = undefined;
    let _loc4_: any = undefined;
    let _loc5_: any = undefined;
    if (this.choose_delay != 0) {
      --this.choose_delay;
    }
    this.FWP._obj[this.choose_worm_fid].x = this.FWP._obj[this.worms[this.cur_worm].fid].x;
    this.FWP._obj[this.choose_worm_fid].y = this.FWP._obj[this.worms[this.cur_worm].fid].y - 70;
    this.FWP._obj[this.choose_worm_fid].visible = true;
    this.choose_worm_timeout -= this.FWP.FPS;
    if (this.choose_worm_timeout <= 0) {
      this.choose_worm = false;
      this.check_ready(0);
      this.FWP._obj[this.choose_worm_fid].visible = false;
      return;
    }
    if (this.FWP.REPLAY) {
      _loc2_ = this.read_key_press(this.timer);
      _loc1_ = _loc2_.other;
    } else {
      _loc1_ = this.battle_input ? this.battle_input.read_key() : this.FWP.KEY_PRESSED;
    }
    if (_loc1_ == "enter" && this.choose_delay == 0) {
      this.choose_delay = 20;
      _loc3_ = this.choose_worm_id;
      _loc4_ = 0;
      do {
        _loc3_++;
        if (_loc3_ > this.worms[0]) {
          _loc3_ = 1;
        }
        if (this.worms[_loc3_].state == "ok" && this.FWP._obj[this.worms[_loc3_].fid].wteam == this.cur_team) {
          this.choose_worm_id = _loc3_;
          break;
        }
      } while (++_loc4_ <= 100);
      this.cur_worm = this.choose_worm_id;
      this.check_displace(true);
      return;
    }
    if (_loc1_ == "escape") {
      this.FWP._obj[this.choose_worm_fid].visible = false;
      _loc5_ = this.FWP._obj[this.worms[this.choose_worm_id].fid];
      _loc5_.states.resting = false;
      _loc5_.states.active = true;
      _loc5_.vars.timeout = this.choose_worm_timeout;
      this.OBJ[this.FWP._obj[this.worms[this.choose_worm_id].fid].pid].ready = false;
      this.choose_worm = false;
    }
  }

  ai(param1: any): any {
    param1 = as3.str(param1);
    let _temp_14: any = undefined;
    let _loc2_: any = undefined;
    let _loc3_: any = undefined;
    let _loc4_: any = undefined;
    let _loc5_: any = undefined;
    let _loc6_: any = undefined;
    let _loc7_: any = undefined;
    let _loc8_: any = undefined;
    let _loc9_: any = undefined;
    let _loc10_: any = undefined;
    let _loc11_: any = undefined;
    let _loc12_: any = undefined;
    let _loc13_: any = undefined;
    let _loc14_: any = undefined;
    let _loc15_: any = undefined;
    let _loc16_: any = undefined;
    let _loc17_: any = undefined;
    let _loc18_: any = undefined;
    let _loc19_: any = undefined;
    let _loc20_: any = undefined;
    let _loc21_: any = undefined;
    let _loc22_: any = undefined;
    let _loc23_: any = undefined;
    let _loc24_: any = undefined;
    let _loc25_: any = undefined;
    let _loc26_: any = undefined;
    let _loc27_: any = undefined;
    let _loc28_: any = undefined;
    let _loc29_: any = undefined;
    let _loc30_: any = undefined;
    let _loc31_: any = undefined;
    let _loc32_: any = undefined;
    let _loc33_: any = undefined;
    let _loc34_: any = undefined;
    let _loc35_: any = undefined;
    let _loc36_: any = undefined;
    if (this.ai_sleep != 0) {
      --this.ai_sleep;
      return;
    }
    if (param1 == "init") {
      this.proc_action.act = "";
      this.ai_result = {
        "center": {
          "steps": 0,
          "wind": new Array<any>(false, {}),
          "gravity": new Array<any>(false, {}),
          "linear": new Array<any>(false, {}),
          "airstrike": new Array<any>(false, {})
        },
        "not_center": {
          "steps": 0,
          "wind": new Array<any>(false, {}),
          "gravity": new Array<any>(false, {}),
          "linear": new Array<any>(false, {}),
          "airstrike": new Array<any>(false, {})
        }
      };
      this.ai_max_targets = 0;
      _loc3_ = 1;
      while (_loc3_ <= this.OBJ[0]) {
        if (!this.OBJ[_loc3_].free) {
          _loc4_ = this.FWP._obj[this.OBJ[_loc3_].fid];
          if (_loc4_.model == "W" && this.teams[_loc4_.wteam].color != this.teams[this.cur_team].color && this.worms[_loc4_.wid].state == "ok") {
            ++this.ai_max_targets;
            for (_loc5_ of as3.keys(this.ai_result.center)) {
              if (_loc5_ != "steps") {
                this.ai_result.center[_loc5_][this.ai_max_targets] = {
                  "pid": _loc3_,
                  "mode": 0,
                  "dmg": 0,
                  "dx": Number.POSITIVE_INFINITY,
                  "angle": 0,
                  "force": 0,
                  "timeout": 0
                };
                this.ai_result.not_center[_loc5_][this.ai_max_targets] = {
                  "pid": _loc3_,
                  "mode": 0,
                  "dmg": 0,
                  "dx": Number.POSITIVE_INFINITY,
                  "angle": 0,
                  "force": 0,
                  "timeout": 0
                };
              }
            }
          }
        }
        _loc3_++;
      }
      this.ai_pos = "center";
      this.ai_weapon = "wind";
      this.ai_target = 1;
      this.ai_virtual_fid = "obj" + String(this.make_object("V", "virtual", "", { "x": 0, "y": 0 }));
      this.proc_action.act = "ai calc";
      this.proc_timeout = 0;
      return;
    }
    if (param1 == "calc") {
      _loc2_ = 1;
      while (_loc2_ <= this.worms[0]) {
        if (this.worms[_loc2_].state == "ok" && this.cur_worm != _loc2_) {
          this.FWP._world.set_land_mask(this.FWP._obj[this.worms[_loc2_].fid].x, this.FWP._obj[this.worms[_loc2_].fid].y, this.FWP._obj[this.worms[_loc2_].fid].vars.direction);
        }
        _loc2_++;
      }
      _loc6_ = this.FWP._obj[this.ai_virtual_fid];
      _loc7_ = this.FWP._obj[this.OBJ[this.ai_result[this.ai_pos][this.ai_weapon][this.ai_target].pid].fid];
      _loc8_ = this.FWP._obj[this.worms[this.cur_worm].fid];
      _loc9_ = _loc7_.x - _loc8_.x;
      _loc10_ = _loc7_.y - _loc8_.y;
      this.ai_dest_iters = Math.round(this.ai_dest_time / this.FWP.FPS);
      _loc11_ = 0;
      _loc12_ = this.ai_dest_iters;
      while (_loc12_ > 0) {
        _loc11_ += _loc12_;
        _loc12_--;
      }
      if (this.ai_weapon == "wind") {
        _loc13_ = Math.atan((_loc10_ - _loc11_ * this.G) / (_loc9_ - _loc11_ * this.W));
        _loc14_ = (_loc10_ - _loc11_ * this.G) / (this.ai_dest_iters * Math.sin(_loc13_));
      } else if (this.ai_weapon == "gravity") {
        _loc13_ = Math.atan((_loc10_ - _loc11_ * this.G) / _loc9_);
        _loc14_ = (_loc10_ - _loc11_ * this.G) / (this.ai_dest_iters * Math.sin(_loc13_));
      } else {
        _loc13_ = Math.atan2(_loc10_, _loc9_);
        _loc14_ = 9;
      }
      if (this.mod(_loc14_) <= 21) {
        _loc15_ = _loc14_ * Math.cos(_loc13_);
        _loc16_ = _loc14_ * Math.sin(_loc13_);
        _loc6_.x = _loc8_.x;
        _loc6_.y = _loc8_.y;
        _loc6_.vars.vx = _loc15_;
        _loc6_.vars.vy = _loc16_;
        _loc6_.FLAGS.DAMAGE = this.ai_weapon == "linear" ? 200 : 50;
        _loc6_.FLAGS.DIAMETER = this.ai_weapon == "linear" ? 75 : 100;
        this.ai_trav_time = 0;
        while (true) {
          _loc17_ = _loc6_.movement_return();
          if (Boolean(_loc17_.hit) || this.ai_trav_time >= this.ai_dest_time) {
            _loc18_ = _loc6_.explode_return();
            if (this.ai_trav_time * this.FWP.FPS >= 800) {
              _loc19_ = this.ai_result[this.ai_pos][this.ai_weapon];
              _loc19_[0] = true;
              _loc20_ = 10;
              if (_loc18_.damage > 0) {
                _loc20_ = 1;
              } else if (_loc18_.damage < 0 && !_loc18_.only_me) {
                _loc20_ = 2;
              } else if (_loc18_.damage == 0) {
                _loc20_ = 3;
              } else if (_loc18_.damage < 0 && Boolean(_loc18_.only_me)) {
                _loc20_ = 4;
              }
              _loc21_ = false;
              _loc22_ = -1;
              if (_loc19_[this.ai_target].mode == 0) {
                _loc21_ = true;
              }
              if (_loc19_[this.ai_target].mode > _loc20_) {
                _loc21_ = true;
              }
              if (_loc19_[this.ai_target].mode == _loc20_) {
                _temp_14 = Math;
                _loc6_.x - _loc7_.x;
                _loc22_ = _temp_14.sqrt(2 + Math.pow(_loc6_.y - _loc7_.y, 2));
                if (_loc20_ < 3 && _loc19_[this.ai_target].dmg < _loc18_.damage) {
                  _loc21_ = true;
                }
                if (_loc20_ == 3 && _loc19_[this.ai_target].dx > _loc22_) {
                  _loc21_ = true;
                }
              }
              if (_loc21_) {
                _loc19_[this.ai_target].mode = _loc20_;
                _loc19_[this.ai_target].dmg = _loc18_.damage;
                _loc19_[this.ai_target].angle = _loc13_;
                _loc19_[this.ai_target].force = _loc14_;
                _loc19_[this.ai_target].timeout = this.ai_trav_time;
                if (_loc22_ != -1) {
                  _loc19_[this.ai_target].dx = _loc22_;
                }
              }
              if (Boolean(_loc17_.direct_hit) && Boolean(this.mod(_loc7_.x - _loc17_.hit_x) <= 5) && this.mod(_loc7_.y - _loc17_.hit_y) <= 5) {
              }
            }
            break;
          }
          if (_loc6_.y > this.FWP._world.LIMIT_DOWN) {
            break;
          }
          if (this.ai_weapon == "linear" && (_loc6_.y > this.FWP._world.LIMIT_DOWN || _loc6_.y < this.FWP._world.LIMIT_UP && _loc6_.x > this.FWP._world.LIMIT_RIGHT || _loc6_.x < this.FWP._world.LIMIT_LEFT)) {
            break;
          }
          if (this.ai_weapon == "wind") {
            _loc6_.vars.vx += this.W;
          }
          if (this.ai_weapon == "wind" || this.ai_weapon == "gravity") {
            _loc6_.vars.vy += this.G;
          }
          _loc6_.vars.vx = this.mod(_loc6_.vars.vx) > this.MAXIMUM_SPEED ? this.sign(_loc6_.vars.vx) * this.MAXIMUM_SPEED : _loc6_.vars.vx;
          _loc6_.vars.vy = this.mod(_loc6_.vars.vy) > this.MAXIMUM_SPEED ? this.sign(_loc6_.vars.vy) * this.MAXIMUM_SPEED : _loc6_.vars.vy;
          _loc6_.x += _loc6_.vars.vx;
          _loc6_.y += _loc6_.vars.vy;
          this.ai_trav_time += this.FWP.FPS;
        }
      }
      this.ai_dest_time += 200;
      if (this.ai_dest_time > 5200 || this.ai_weapon == "linear") {
        this.proc_action.act = "ai get next";
        return;
      }
    }
    if (param1 == "get next") {
      _loc2_ = 1;
      while (_loc2_ <= this.worms[0]) {
        if (this.worms[_loc2_].state == "ok" && this.cur_worm != _loc2_) {
          this.FWP._world.clear_land_mask(this.FWP._obj[this.worms[_loc2_].fid].x, this.FWP._obj[this.worms[_loc2_].fid].y);
        }
        _loc2_++;
      }
      if (this.ai_weapon == "wind") {
        this.ai_dest_time = 100;
      }
      if (this.ai_weapon == "gravity") {
        this.ai_dest_time = 700;
      }
      if (this.ai_weapon == "linear") {
        this.ai_dest_time = 10000;
      }
      if (this.ai_target < this.ai_max_targets) {
        ++this.ai_target;
        this.proc_action.act = "ai calc";
        return;
      }
      if (this.ai_weapon == "wind") {
        this.ai_weapon = "gravity";
        this.ai_target = 1;
        this.proc_action.act = "ai calc";
        return;
      }
      if (this.ai_weapon == "gravity") {
        this.ai_weapon = "linear";
        this.ai_target = 1;
        this.proc_action.act = "ai calc";
        return;
      }
      if (this.ai_pos == "center" && !this.FWP._obj[this.worms[this.cur_worm].fid].vars.paralyzed) {
        this.ai_pos = "not_center";
        this.ai_weapon = "wind";
        this.ai_target = 1;
        this.proc_action.act = "ai move init";
        return;
      }
      this.proc_action.act = "ai find best";
      return;
    }
    if (param1 == "move init") {
      this.ai_move_dir = this.FWP.pseudo_random(0, 1) == 0 ? "left" : "right";
      this.ai_move_steps = 0;
      this.ai_move_state = 0;
      this.proc_action.act = "ai move";
      return;
    }
    if (param1 == "move") {
      _loc23_ = this.FWP._obj[this.worms[this.cur_worm].fid].goto_return(this.ai_move_dir);
      if (this.mod(this.ai_move_steps) >= 80) {
        this.ai_result.not_center.steps = this.ai_move_steps;
        this.proc_action.act = "ai calc";
        return;
      }
      if (_loc23_ < 3) {
        this.ai_buttonid = this.ai_move_dir;
        this.ai_move_steps += this.ai_move_dir == "left" ? -1 : 1;
      } else {
        if (this.mod(this.ai_move_steps) >= 15) {
          this.ai_result.not_center.steps = this.ai_move_steps;
          this.proc_action.act = "ai calc";
          return;
        }
        if (this.ai_move_state != 0) {
          this.ai_result.not_center.steps = this.ai_move_steps;
          this.proc_action.act = "ai calc";
          return;
        }
        this.ai_move_dir = this.ai_move_dir == "left" ? "right" : "left";
        ++this.ai_move_state;
        this.ai_sleep = 25;
      }
    }
    if (param1 == "find best") {
      this.remove_object(this.FWP._obj[this.ai_virtual_fid], this.FWP._obj[this.ai_virtual_fid].pid, true);
      this.ai_best_result = {
        "pos": "",
        "weapon": "",
        "mode": 0,
        "dmg": 0,
        "dx": Number.POSITIVE_INFINITY,
        "angle": 0,
        "force": 0,
        "timeout": 0
      };
      this.ai_best_weapon = { "wind": "", "gravity": "", "linear": "", "airstirke": "" };
      for (_loc24_ of as3.keys(this.teams[this.cur_team].weapons)) {
        if (this.teams[this.cur_team].weapons[_loc24_][1] != 0) {
          if (this.FWP.WEAPONS_DEF[_loc24_].ai_type != "") {
            if (this.ai_best_weapon[this.FWP.WEAPONS_DEF[_loc24_].ai_type] == "") {
              this.ai_best_weapon[this.FWP.WEAPONS_DEF[_loc24_].ai_type] = _loc24_;
            } else if (this.FWP.WEAPONS_DEF[_loc24_].level > this.FWP.WEAPONS_DEF[this.ai_best_weapon[this.FWP.WEAPONS_DEF[_loc24_].ai_type]].level && this.FWP.WEAPONS_DEF[this.ai_best_weapon[this.FWP.WEAPONS_DEF[_loc24_].ai_type]].level != 0 || this.FWP.WEAPONS_DEF[_loc24_].level == 0) {
              this.ai_best_weapon[this.FWP.WEAPONS_DEF[_loc24_].ai_type] = _loc24_;
            }
          }
        }
      }
      _loc27_ = 0;
      while (_loc27_ <= 1) {
        if (_loc27_ == 0) {
          _loc26_ = "not_center";
        }
        if (_loc27_ == 1) {
          _loc26_ = "center";
        }
        _loc28_ = 0;
        while (_loc28_ <= 2) {
          if (_loc28_ == 0) {
            _loc25_ = "gravity";
          }
          if (_loc28_ == 1) {
            _loc25_ = "wind";
          }
          if (_loc28_ == 2) {
            _loc25_ = "linear";
          }
          if (this.ai_best_weapon[_loc25_] != "") {
            if (this.ai_result[_loc26_][_loc25_][0]) {
              _loc29_ = 1;
              while (_loc29_ <= this.ai_max_targets) {
                _loc30_ = this.ai_result[_loc26_][_loc25_][_loc29_];
                _loc31_ = false;
                if (this.ai_best_result.mode == 0) {
                  _loc31_ = true;
                }
                if (this.ai_best_result.mode > _loc30_.mode && _loc30_.mode != 0) {
                  _loc31_ = true;
                }
                if (this.ai_best_result.mode == _loc30_.mode) {
                  if (_loc30_.mode < 3 && _loc30_.dmg == this.ai_best_result.dmg && _loc25_ == "wind") {
                    _loc31_ = true;
                  }
                  if (_loc30_.mode < 3 && _loc30_.dmg > this.ai_best_result.dmg) {
                    _loc31_ = true;
                  }
                  if (_loc30_.mode == 3 && _loc30_.dx < this.ai_best_result.dx) {
                    _loc31_ = true;
                  }
                }
                if (_loc31_) {
                  this.ai_best_result.mode = _loc30_.mode;
                  this.ai_best_result.dmg = _loc30_.dmg;
                  this.ai_best_result.angle = _loc30_.angle;
                  this.ai_best_result.force = _loc30_.force;
                  this.ai_best_result.timeout = _loc30_.timeout;
                  if (this.ai_best_result.mode == 3) {
                    this.ai_best_result.dx = _loc30_.dx;
                  }
                  this.ai_best_result.weapon = _loc25_;
                  this.ai_best_result.pos = _loc26_;
                }
                _loc29_++;
              }
            }
          }
          _loc28_++;
        }
        _loc27_++;
      }
      this.FWP.deep_trace(this.ai_best_result);
      if (this.ai_best_result.mode == 4 || this.ai_best_result.mode == 0) {
        this.proc_action.act = "ai skip go";
        this.ai_sleep = 25;
        this.ai_fire_state.state = "set weapon";
        this.ai_fire_state.timeout = 25;
        return;
      }
      if (this.ai_best_result.pos == "center" && this.ai_result.not_center.steps != 0) {
        this.proc_action.act = "ai move to best";
        this.ai_sleep = 25;
        return;
      }
      this.proc_action.act = "ai fire";
      this.ai_sleep = 25;
      this.ai_fire_state.state = "set weapon";
      this.ai_fire_state.timeout = 25;
      return;
    }
    if (param1 == "move to best") {
      if (this.ai_result.not_center.steps > 0) {
        this.ai_move_dir = "left";
      } else {
        this.ai_move_dir = "right";
      }
      if (this.ai_result.not_center.steps == 0) {
        this.proc_action.act = "ai fire";
        this.ai_fire_state.state = "set weapon";
        this.ai_fire_state.timeout = 25;
        this.ai_sleep = 25;
        return;
      }
      if (this.ai_result.not_center.steps > 0) {
        --this.ai_result.not_center.steps;
      } else {
        ++this.ai_result.not_center.steps;
      }
      this.ai_buttonid = this.ai_move_dir;
    }
    if (param1 == "fire") {
      if (this.ai_fire_state.state != "") {
        if (this.ai_fire_state.timeout != 0) {
          --this.ai_fire_state.timeout;
          return;
        }
      }
      _loc32_ = this.ai_best_weapon[this.ai_best_result.weapon];
      _loc35_ = this.ai_corean_random();
      if (this.ai_best_result.angle) {
        this.ai_best_result.angle += _loc35_.angle;
      }
      if (this.ai_best_result.force) {
        this.ai_best_result.force += _loc35_.force;
      }
      if (this.ai_best_result.angle > 90) {
        this.ai_best_result.angle = 90;
      }
      if (this.ai_best_result.angle < -90) {
        this.ai_best_result.angle = -90;
      }
      if (this.ai_best_result.weapon != "linear") {
        _loc33_ = this.ai_best_result.force * Math.cos(this.ai_best_result.angle);
        _loc34_ = this.ai_best_result.force * Math.sin(this.ai_best_result.angle);
      } else {
        _loc33_ = 40 * Math.cos(this.ai_best_result.angle);
        _loc34_ = 40 * Math.sin(this.ai_best_result.angle);
      }
      _loc36_ = this.FWP._obj[this.worms[this.cur_worm].fid];
      if (this.ai_fire_state.state == "set weapon") {
        if (_loc36_.vars.direction == -1 && _loc33_ < 0 || _loc36_.vars.direction == 1 && _loc33_ > 0) {
          _loc36_.vars.direction *= -1;
          _loc36_.worm_modify_sprite("tail");
          _loc36_.worm_modify_sprite("tail");
        }
        if (this.ai_best_result.weapon != "linear") {
          _loc36_.vars.crosshair = Math.round(this.ai_best_result.angle * 180 / Math.PI) * this.sign(-this.ai_best_result.force);
        } else {
          _loc36_.vars.crosshair = Math.round(this.ai_best_result.angle * 180 / Math.PI);
          if (_loc36_.vars.direction == -1) {
            _loc36_.vars.crosshair *= -1;
          }
          if (_loc36_.vars.direction == 1) {
            if (_loc36_.vars.crosshair > 0) {
              _loc36_.vars.crosshair -= 180;
            } else {
              _loc36_.vars.crosshair += 180;
            }
          }
        }
        _loc36_.weapon.set_w = this.FWP.WEAPONS_DEF[_loc32_].id;
        _loc36_.weapon.set_w_range = 1;
        this.ai_fire_state.state = "fire";
        this.ai_fire_state.timeout = 75;
        return;
      }
      if (this.ai_fire_state.state == "fire") {
        _loc36_.weapon_flags.MULTIPLESHOT = false;
        if (this.ai_best_result.weapon == "linear") {
          this.ai_proj_prop.vx = _loc33_;
          this.ai_proj_prop.vy = _loc34_;
        }
        if (this.ai_best_result.weapon == "linear" && Boolean(this.ai_spressed)) {
          this.ai_spressed = false;
          this.proc_action.act = "";
          return;
        }
        this.ai_spressed = true;
        if (_loc36_.states.firing > this.mod(this.ai_best_result.force) && this.ai_best_result.weapon != "linear") {
          this.ai_spressed = false;
          this.ai_proj_prop.vx = _loc33_;
          this.ai_proj_prop.vy = _loc34_;
          this.ai_proj_prop.timeout = this.ai_best_result.timeout;
          this.proc_action.act = "";
          this.FWP.bug_report += "Worm " + this.cur_worm + " fires with: " + _loc32_ + " at " + _loc36_.x + ", " + _loc36_.y + "\n";
        }
      }
    }
    if (param1 == "skip go") {
      if (this.ai_fire_state.state != "") {
        if (this.ai_fire_state.timeout != 0) {
          --this.ai_fire_state.timeout;
          return;
        }
      }
      if (this.ai_fire_state.state == "set weapon") {
        this.FWP._obj[this.worms[this.cur_worm].fid].weapon.set_w = 61;
        this.FWP._obj[this.worms[this.cur_worm].fid].weapon.set_w_range = 1;
        this.ai_fire_state.state = "fire";
        this.ai_fire_state.timeout = 50;
        return;
      }
      if (this.ai_fire_state.state == "fire") {
        this.ai_spressed = true;
        if (!this.FWP._obj[this.worms[this.cur_worm].fid].states.firecontrol) {
          this.ai_spressed = false;
          this.proc_action.act = "";
        }
      }
    }
  }

  ai_corean_random(): any {
    let _loc1_: any = 0;
    let _loc2_: any = 0;
    let _loc3_: any = this.teams[this.cur_team].cpu_level;
    let _loc4_: any = this.FWP.get_stealth_eff(_loc3_, this.CUR_STEALTH);
    let _loc5_: any = this.FWP.COREAN_RANDOM[_loc4_].angle_diap;
    let _loc6_: any = this.FWP.COREAN_RANDOM[_loc4_].angle_mult;
    let _loc7_: any = this.FWP.COREAN_RANDOM[_loc4_].force_diap;
    let _loc8_: any = this.FWP.COREAN_RANDOM[_loc4_].force_mult;
    if (_loc5_ != 0) {
      _loc2_ = this.FWP.pseudo_random(-_loc5_, _loc5_) / _loc6_;
    }
    if (_loc7_ != 0) {
      _loc1_ = this.FWP.pseudo_random(-_loc7_, _loc7_) * _loc8_;
    }
    return { "angle": _loc2_, "force": _loc1_ };
  }

  check_ready(param1: number): any {
    let _loc2_: any = undefined;
    if (this.choose_worm) {
      return;
    }
    _loc2_ = 2;
    while (_loc2_ <= this.OBJ[0]) {
      if (!this.OBJ[_loc2_].free && !this.OBJ[_loc2_].ready && this.OBJ[_loc2_].model != "V" && this.OBJ[_loc2_].model != "E") {
        // PORT: deliberate fix of a hang the original has too (proc.as:1981-1993, obj.as:546-557). While the map
        // PORT: waits for a target (mousecontrol: teleport, the strikes, girders) every object that is not resting
        // PORT: stops before its movement (obj.ongoing); only a valid target click, Escape or new_move end that mode.
        // PORT: An object stopped in flight (a crate dropped at the move's start, a worm thrown by a blast) never
        // PORT: comes to rest then, so a wait for every object to be ready never ends while the map waits:
        // PORT:  - the end of the move: the current worm's turn is over (its timer ran out or it was hit:
        // PORT:    states.active false). The target mode ends here, as new_move would end it (a click after the turn
        // PORT:    ended no longer counts);
        // PORT:  - the wait between two girders of a girder pack (wait_for_ready, obj.worm_fire): the worm rests, so
        // PORT:    its turn timer stands still too. The worm goes on at once, as the end of that wait ("return wfr")
        // PORT:    lets it, and places the next girder while the map keeps waiting; its timer runs again and ends the
        // PORT:    turn (the case above).
        // PORT: A move whose objects are all ready goes on exactly as before.
        if (this.mousecontrol) {
          if (this.cur_worm != 0 && this.FWP._obj[this.worms[this.cur_worm].fid] && !this.FWP._obj[this.worms[this.cur_worm].fid].states.active) {
            this.remove_mousecontrol();
          } else if (this.wait_for_ready != 0 && this.proc_action.act == "" && !this.OBJ[this.wait_for_ready].free) {
            this.FWP._obj[this.OBJ[this.wait_for_ready].fid].states.resting = false;
            this.OBJ[this.wait_for_ready].ready = false;
            this.wait_for_ready = 0;
          }
        }
        return;
      }
      _loc2_++;
    }
    _loc2_ = 2;
    while (_loc2_ <= this.OBJ[0]) {
      if (!this.OBJ[_loc2_].free && this.OBJ[_loc2_].model == "W") {
        if (this.FWP._obj[this.OBJ[_loc2_].fid].vars.health <= 0) {
          this.worm_pid_to_die = _loc2_;
          this.proc_action.act = "death loop";
          this.proc_timeout = 500;
          if (this.FWP._obj[this.OBJ[_loc2_].fid].wteam == 1) {
            this.ach_kill = true;
          }
          if (this.cur_team == 1 && this.ach_last_wptype != "" && this.FWP._obj[this.OBJ[_loc2_].fid].wteam != 1) {
            ++this.ach_killed[this.ach_last_wptype];
          }
          return;
        }
      }
      _loc2_++;
    }
    if (this.wait_for_ready != 0) {
      this.proc_action.act = "return wfr";
      this.proc_timeout = 1000;
      return;
    }
    this.optim_obj();
    this.proc_action.act = "new move";
    this.proc_timeout = 500;
  }

  check_teams(): void {
    let _loc3_: any = undefined;
    let _loc1_: any = 0;
    let _loc2_: any = 1;
    while (_loc2_ <= this.teams[0]) {
      if (this.teams[_loc2_].state == "ok") {
        _loc1_ = 0;
        _loc3_ = 1;
        while (_loc3_ <= this.OBJ[0]) {
          if (this.OBJ[_loc3_].model == "W" && !this.OBJ[_loc3_].free) {
            if (this.worms[this.FWP._obj[this.OBJ[_loc3_].fid].wid].state == "ok" && this.FWP._obj[this.OBJ[_loc3_].fid].wteam == _loc2_) {
              _loc1_++;
            }
          }
          _loc3_++;
        }
        if (_loc1_ == 0) {
          this.teams[_loc2_].state = "empty";
        }
      }
      _loc2_++;
    }
  }

  check_displace(param1: boolean, param2: any = "normal"): any {
    param1 = Boolean(param1);
    param2 = as3.str(param2);
    // PORT (wide screens): the edges of what the screen shows (the window itself without a wide host): the camera
    // follows and the markers of objects out of view sit at them (FWP.view_rect; presentation only).
    const _vr: any = this.FWP.view_rect();
    const _vs: any = this.FWP.view_rect(true);
    let _loc3_: any = undefined;
    let _loc10_: any = undefined;
    let _loc11_: any = undefined;
    let _loc12_: any = undefined;
    let _loc13_: any = undefined;
    let _loc14_: any = undefined;
    let _loc15_: any = undefined;
    let _loc16_: any = undefined;
    let _loc17_: any = undefined;
    let _loc18_: any = undefined;
    let _loc19_: any = undefined;
    let _loc20_: any = undefined;
    let _loc21_: any = undefined;
    let _loc22_: any = undefined;
    let _loc4_: any = 0;
    let _loc5_: any = 0;
    let _loc6_: any = false;
    let _loc7_: any = false;
    let _loc8_: any = 0;
    let _loc9_: any = 0;
    for (_loc11_ of as3.keys(this.FWP._interf.distance_boxes)) {
      this.FWP._interf.distance_boxes[_loc11_].visible = false;
    }
    _loc3_ = 1;
    while (_loc3_ <= this.OBJ[0]) {
      if (!this.OBJ[_loc3_].free) {
        if ((Boolean(this.FWP._obj[this.OBJ[_loc3_].fid].model == "C" || this.FWP._obj[this.OBJ[_loc3_].fid].model == "P" || this.FWP._obj[this.OBJ[_loc3_].fid].model == "M")) && (Boolean(this.FWP._obj[this.OBJ[_loc3_].fid].vars.vx != 0 || this.FWP._obj[this.OBJ[_loc3_].fid].vars.vy != 0 || this.FWP._obj[this.OBJ[_loc3_].fid].states.sliding)) || this.FWP._obj[this.OBJ[_loc3_].fid].model == "W" && this.worms[this.FWP._obj[this.OBJ[_loc3_].fid].wid].state == "ok" && (this.FWP._obj[this.OBJ[_loc3_].fid].vars.vs != 0 || this.FWP._obj[this.OBJ[_loc3_].fid].vars.vx != 0 || this.FWP._obj[this.OBJ[_loc3_].fid].vars.vy != 0 || this.FWP._obj[this.OBJ[_loc3_].fid].states.flying != 0)) {
          _loc12_ = 0;
          _loc13_ = 0;
          _loc14_ = this.FWP._obj[this.OBJ[_loc3_].fid].x + this.position_x;
          _loc15_ = this.FWP._obj[this.OBJ[_loc3_].fid].y + this.position_y;
          _loc10_ = Number(String(this.OBJ[_loc3_].fid).split("obj")[1]);
          if (_loc14_ <= _vr.x0 - 10) {
            _loc12_ = -1;
          } else if (_loc14_ >= _vr.x1 + 10) {
            _loc12_ = 1;
          }
          if (_loc15_ <= _vr.y0 - 10) {
            _loc13_ = -1;
          } else if (_loc15_ >= _vr.y1 + 10) {
            _loc13_ = 1;
          }
          if (_loc12_ == 0 && _loc13_ == 0) {
            this.FWP._interf.distance_boxes["box" + _loc10_].visible = false;
          } else {
            this.FWP._interf.distance_boxes["box" + _loc10_].visible = true;
            // PORT (wide screens): the marker drawn larger on a phone, its number as large as the worms' labels
            // (FWP.distance_box_scale), as far in from the screen's side as its size needs. Presentation only.
            const _dk: number = this.FWP.distance_box_scale();
            this.FWP._interf.distance_boxes["box" + _loc10_].scaleX = this.FWP._interf.distance_boxes["box" + _loc10_].scaleY = _dk;
            if (_loc12_ == -1) {
              this.FWP._interf.distance_boxes["box" + _loc10_].x = _vs.x0 + 18 * _dk;
            }
            if (_loc12_ == 1) {
              this.FWP._interf.distance_boxes["box" + _loc10_].x = _vs.x1 - 18 * _dk;
            }
            if (_loc13_ == -1) {
              this.FWP._interf.distance_boxes["box" + _loc10_].y = _vs.y0 + 9 * _dk;
            }
            if (_loc13_ == 1) {
              this.FWP._interf.distance_boxes["box" + _loc10_].y = _vs.y1 - 9 * _dk;
            }
            if (_loc12_ == 0) {
              this.FWP._interf.distance_boxes["box" + _loc10_].x = this.FWP._obj[this.OBJ[_loc3_].fid].x + this.position_x;
            }
            if (_loc13_ == 0) {
              this.FWP._interf.distance_boxes["box" + _loc10_].y = this.FWP._obj[this.OBJ[_loc3_].fid].y + this.position_y;
            }
            // PORT (wide screens): along its side, clear of the HUD at the top and the touch controls. Presentation.
            if (_loc12_ == 0 || _loc13_ == 0) {
              this.FWP.distance_box_clear(this.FWP._interf.distance_boxes["box" + _loc10_], _loc12_ == 0);
            }
            _loc16_ = 0;
            _loc17_ = 0;
            _loc18_ = 0;
            _loc19_ = 0;
            _loc20_ = "x";
            if (_loc12_ == 1) {
              _loc16_ = _loc14_ - _vr.x1;
              _loc20_ = "x";
            }
            if (_loc12_ == -1) {
              _loc16_ = _vr.x0 - _loc14_;
              _loc20_ = "x";
            }
            if (_loc13_ == 1) {
              _loc17_ = _loc15_ - _vr.y1;
              _loc20_ = "y";
            }
            if (_loc13_ == -1) {
              _loc17_ = _vr.y0 - _loc15_;
              _loc20_ = "y";
            }
            if (_loc12_ != 0 && _loc13_ != 0) {
              _loc18_ = this.mod(_loc16_) + this.mod(_loc17_);
              _loc20_ = "xy";
            }
            if (_loc20_ == "x") {
              _loc19_ = _loc16_;
            } else if (_loc20_ == "y") {
              _loc19_ = _loc17_;
            } else {
              _loc19_ = _loc18_;
            }
            _loc19_ = Math.round(this.mod(_loc19_));
            if (_loc19_ > 9999) {
              _loc19_ = 9999;
            }
            this.FWP._interf.distance_boxes["box" + _loc10_].distance.text = String(_loc19_);
          }
        }
      }
      _loc3_++;
    }
    if (Boolean(this.mouse_down) && (this.mouseX < _vr.x0 + 10 || this.mouseX > _vr.x1 - 10 || this.mouseY < _vr.y0 + 10 || this.mouseY > _vr.y1 - 10)) {
      this.mouse_down = false;
    }
    if (Boolean(this.mouse_down) && !this.wpsheet) {
      if (this.click_coords.x == undefined) {
        this.click_coords.x = this.mouseX - this.position_x;
        this.click_coords.y = this.mouseY - this.position_y;
        return;
      }
      _loc21_ = this.mouseX - this.position_x;
      _loc22_ = this.mouseY - this.position_y;
      if (_loc21_ != this.click_coords.x || _loc22_ != this.click_coords.y) {
        this.game_displace(_loc21_ - this.click_coords.x, _loc22_ - this.click_coords.y);
        this.click_coords.x = this.mouseX - this.position_x;
        this.click_coords.y = this.mouseY - this.position_y;
      }
      return;
    }
    if (this.click_coords.x != undefined) {
      this.click_coords = {};
    }
    if (param2 == "paused") {
      if (_loc4_ != 0 || _loc5_ != 0) {
        this.game_displace(_loc4_, _loc5_);
      }
      return;
    }
    if (this.displace_seek_time > 0) {
      --this.displace_seek_time;
    }
    _loc3_ = 1;
    while (_loc3_ <= this.OBJ[0]) {
      if (!this.OBJ[_loc3_].free) {
        if (this.FWP._obj[this.OBJ[_loc3_].fid].model == "P" && (Boolean(this.FWP._obj[this.OBJ[_loc3_].fid].FLAGS.GRAVITY) || Boolean(this.FWP._obj[this.OBJ[_loc3_].fid].FLAGS.WIND))) {
          if (this.displace_seek_time <= 0 || this.displace_seek_type == "P" && this.displace_seek_obj == _loc3_) {
            if (!this.FWP._obj[this.OBJ[_loc3_].fid].FLAGS.NOSEEKING && (Boolean(this.FWP._obj[this.OBJ[_loc3_].fid].vars.vx != 0 || this.FWP._obj[this.OBJ[_loc3_].fid].vars.vy != 0) || Boolean(this.FWP._obj[this.OBJ[_loc3_].fid].states.sliding))) {
              _loc4_ = 0;
              _loc5_ = 0;
              if (this.FWP._obj[this.OBJ[_loc3_].fid].x + this.position_x < _vr.x0 + this.DISPLACE_LIMIT) {
                _loc7_ = true;
                _loc4_ = _vr.x0 + this.DISPLACE_LIMIT - this.FWP._obj[this.OBJ[_loc3_].fid].x - this.position_x;
              } else if (this.FWP._obj[this.OBJ[_loc3_].fid].x + this.position_x > _vr.x1 - this.DISPLACE_LIMIT) {
                _loc7_ = true;
                _loc4_ = -this.FWP._obj[this.OBJ[_loc3_].fid].x - this.position_x + (_vr.x1 - this.DISPLACE_LIMIT);
              }
              if (this.FWP._obj[this.OBJ[_loc3_].fid].y + this.position_y < _vr.y0 + this.DISPLACE_LIMIT && this.FWP._obj[this.OBJ[_loc3_].fid].y + this.position_y > _vr.y0 - this.DISPLACE_LIMIT) {
                _loc7_ = true;
                _loc5_ = -this.FWP._obj[this.OBJ[_loc3_].fid].y - this.position_y + _vr.y0 + this.DISPLACE_LIMIT;
              } else if (this.FWP._obj[this.OBJ[_loc3_].fid].y + this.position_y > _vr.y1 - this.DISPLACE_LIMIT) {
                _loc7_ = true;
                _loc5_ = _vr.y1 - this.DISPLACE_LIMIT - this.FWP._obj[this.OBJ[_loc3_].fid].y - this.position_y;
              }
              if (_loc7_) {
                this.displace_seek_type = "P";
                this.displace_seek_obj = _loc3_;
                this.displace_seek_time = 40;
                break;
              }
            }
          }
        }
      }
      _loc3_++;
    }
    if (!_loc7_ && this.cur_worm != 0) {
      _loc3_ = 1;
      while (_loc3_ <= this.OBJ[0]) {
        if (!this.OBJ[_loc3_].free) {
          if (this.FWP._obj[this.OBJ[_loc3_].fid].model == "W") {
            if (this.displace_seek_time <= 0 || this.displace_seek_type == "W" && this.displace_seek_obj == _loc3_) {
              if (_loc3_ != this.cur_worm && this.worms[this.FWP._obj[this.OBJ[_loc3_].fid].wid].state == "ok" && (this.FWP._obj[this.OBJ[_loc3_].fid].vars.vs != 0 || this.FWP._obj[this.OBJ[_loc3_].fid].states.flying != 0) && (this.FWP._obj[this.OBJ[_loc3_].fid].x + this.position_x < _vr.x0 + this.DISPLACE_LIMIT || this.FWP._obj[this.OBJ[_loc3_].fid].x + this.position_x > _vr.x1 - this.DISPLACE_LIMIT || this.FWP._obj[this.OBJ[_loc3_].fid].y + this.position_y < _vr.y0 + this.DISPLACE_LIMIT || this.FWP._obj[this.OBJ[_loc3_].fid].y + this.position_y > _vr.y1 - this.DISPLACE_LIMIT)) {
                _loc9_ = _loc3_;
                break;
              }
            }
          }
        }
        _loc3_++;
      }
      _loc4_ = 0;
      _loc5_ = 0;
      if (_loc9_ != 0) {
        if (this.FWP._obj[this.OBJ[_loc9_].fid].x + this.position_x < _vr.x0 + this.DISPLACE_LIMIT) {
          _loc4_ = _vr.x0 + this.DISPLACE_LIMIT - this.FWP._obj[this.OBJ[_loc9_].fid].x - this.position_x;
        } else if (this.FWP._obj[this.OBJ[_loc9_].fid].x + this.position_x > _vr.x1 - this.DISPLACE_LIMIT) {
          _loc4_ = -this.FWP._obj[this.OBJ[_loc9_].fid].x - this.position_x + (_vr.x1 - this.DISPLACE_LIMIT);
        }
        if (this.FWP._obj[this.OBJ[_loc9_].fid].y + this.position_y < _vr.y0 + this.DISPLACE_LIMIT && this.FWP._obj[this.OBJ[_loc9_].fid].y + this.position_y > _vr.y0 - this.DISPLACE_LIMIT) {
          _loc5_ = -this.FWP._obj[this.OBJ[_loc9_].fid].y - this.position_y + _vr.y0 + this.DISPLACE_LIMIT;
        } else if (this.FWP._obj[this.OBJ[_loc9_].fid].y + this.position_y > _vr.y1 - this.DISPLACE_LIMIT) {
          _loc5_ = _vr.y1 - this.DISPLACE_LIMIT - this.FWP._obj[this.OBJ[_loc9_].fid].y - this.position_y;
        }
        if (_loc4_ != 0 || _loc5_ != 0) {
          this.displace_seek_type = "W";
          this.displace_seek_obj = _loc9_;
          this.displace_seek_time = 40;
        }
      }
    }
    if (this.cur_worm != 0 && this.worms[this.cur_worm].state == "ok" && !this.mousecontrol && !this.wpsheet) {
      // PORT (touch screens): the current worm's sprite (the worm, its name and health above it) is kept clear of the
      // touch controls' clusters at the shown area's sides (FWP.camera_margin; the camera may go past the world's
      // limits for it: game_displace), its middle at least DISPLACE_LIMIT from a side as in the original; where the
      // two would meet (a narrow view), about the middle between them. Presentation only.
      const _cm: any = this.FWP.camera_margin();
      let _wx0: number = _vr.x0 + this.DISPLACE_LIMIT;
      let _wx1: number = _vr.x1 - this.DISPLACE_LIMIT;
      if (_cm.keep_left > 0 || _cm.keep_right > 0) {
        const _ox: number = this.FWP._obj[this.worms[this.cur_worm].fid].x + this.position_x;
        const _wf: any = this.FWP.hud_focus();
        const _rl: number = _wf ? Math.max(0, _ox - _wf.x) : 0;
        const _rr: number = _wf ? Math.max(0, _wf.x + _wf.width - _ox) : 0;
        _wx0 = Math.max(_wx0, _vr.x0 + (_cm.keep_left > 0 ? _cm.keep_left + _rl : 0));
        _wx1 = Math.min(_wx1, _vr.x1 - (_cm.keep_right > 0 ? _cm.keep_right + _rr : 0));
        if (_wx1 - _wx0 < 40) {
          const _wm: number = Math.round((_wx0 + _wx1) / 2);
          _wx0 = _wm - 20;
          _wx1 = _wm + 20;
        }
      }
      // PORT (wide screens): the current worm's sprite is kept clear of the battle HUD at the top too (the log, the team
      // bars, the wind, the timer: FWP.camera_keep_top), where the camera can move for it (clear_of_hud).
      const _hudHit: boolean = this.hud_over_worm(0, 0);
      if (param1 || (Boolean(!_loc7_ && _loc9_ == 0 && ((this.battle_input && !this.FWP.REPLAY ? this.battle_input.camera_key : this.FWP.KEY_PRESSED) != "none" && this.game_control) || this.FWP._obj[this.worms[this.cur_worm].fid].vars.vs != 0 || this.FWP._obj[this.worms[this.cur_worm].fid].vars.vx != 0 || this.FWP._obj[this.worms[this.cur_worm].fid].vars.vy != 0)) && (Boolean(_hudHit || this.FWP._obj[this.worms[this.cur_worm].fid].x + this.position_x < _wx0 || this.FWP._obj[this.worms[this.cur_worm].fid].x + this.position_x > _wx1 || this.FWP._obj[this.worms[this.cur_worm].fid].y + this.position_y < _vr.y0 + this.DISPLACE_LIMIT || this.FWP._obj[this.worms[this.cur_worm].fid].y + this.position_y > _vr.y1 - this.DISPLACE_LIMIT))) {
        _loc4_ = 0;
        _loc5_ = 0;
        if (this.FWP._obj[this.worms[this.cur_worm].fid].x + this.position_x < _wx0) {
          _loc4_ = _wx0 - this.FWP._obj[this.worms[this.cur_worm].fid].x - this.position_x;
        } else if (this.FWP._obj[this.worms[this.cur_worm].fid].x + this.position_x > _wx1) {
          _loc4_ = -this.FWP._obj[this.worms[this.cur_worm].fid].x - this.position_x + _wx1;
        }
        if (this.FWP._obj[this.worms[this.cur_worm].fid].y + this.position_y < _vr.y0 + this.DISPLACE_LIMIT && this.FWP._obj[this.worms[this.cur_worm].fid].y + this.position_y > _vr.y0 - this.DISPLACE_LIMIT) {
          _loc5_ = -this.FWP._obj[this.worms[this.cur_worm].fid].y - this.position_y + _vr.y0 + this.DISPLACE_LIMIT;
        } else if (this.FWP._obj[this.worms[this.cur_worm].fid].y + this.position_y > _vr.y1 - this.DISPLACE_LIMIT) {
          _loc5_ = _vr.y1 - this.DISPLACE_LIMIT - this.FWP._obj[this.worms[this.cur_worm].fid].y - this.position_y;
        }
        if (_hudHit || this.FWP.camera_keep_top().length) {
          const _clr: any = this.clear_of_hud(_loc4_, _loc5_, _wx0, _wx1, _vr);
          _loc4_ = _clr.x;
          _loc5_ = _clr.y;
        }
        if (_loc4_ != 0 || _loc5_ != 0) {
          this.displace_seek_type = "W";
          this.displace_seek_obj = this.cur_worm;
          this.displace_seek_time = 40;
        }
      }
    }
    if (_loc4_ != 0 || _loc5_ != 0) {
      this.game_displace(_loc4_, _loc5_);
    }
  }

  game_displace(param1: number, param2: number): any {
    // PORT: the clamp moved to camera_clamp (the camera's reach, read also by the framing below); the same numbers.
    const _d: number[] = this.camera_clamp(param1, param2);
    this.position_x += _d[0];
    this.position_y += _d[1];
    this.FWP.display_obj.x = this.position_x;
    this.FWP.display_obj.y = this.position_y;
    this.FWP._world.game_displace();
  }

  /**
   * PORT: how far the camera moves for a displacement of (param1, param2): game_displace's clamp to the world's limits
   * (as the original's, for the edges of what the screen shows, widened by FWP.camera_margin; a view wider than a map's
   * limits shows the map centred). Presentation only.
   */
  camera_clamp(param1: number, param2: number): number[] {
    param1 = Number(param1);
    param2 = Number(param2);
    param1 = Math.ceil(param1);
    param2 = Math.ceil(param2);
    // PORT (wide screens): the world's limits hold for the edges of what the screen shows (the window without a wide
    // host: the original's bounds); a view wider than a map's limits shows the map centred. PORT (touch screens): the
    // camera may go past the side limits by the room the touch controls' clusters take there (FWP.camera_margin), so
    // a worm at a map's end can be shown clear of them; the limits the rules read stay (presentation only).
    const _vr: any = this.FWP.view_rect();
    const _cm: any = this.FWP.camera_margin();
    const _maxX: number = _vr.x0 - this.FWP._world.LIMIT_LEFT + _cm.left;
    const _minX: number = _vr.x1 - this.FWP._world.LIMIT_RIGHT - _cm.right;
    if (this.position_x + param1 > _maxX) {
      param1 = _maxX - this.position_x;
    }
    if (this.position_x + param1 < _minX) {
      param1 = _minX - this.position_x;
    }
    if (_minX > _maxX && _vr.x1 - _vr.x0 > this.FWP.WINDOW_WIDTH) {
      // (Centred as without the margins: the middle of the world's limits.)
      param1 = Math.ceil((_minX + _cm.right + _maxX - _cm.left) / 2) - this.position_x;
    }
    if (this.position_y + param2 > _vr.y0 - this.FWP._world.LIMIT_UP) {
      param2 = _vr.y0 - this.FWP._world.LIMIT_UP - this.position_y;
    }
    if (this.position_y + param2 < _vr.y1 - this.FWP.WINDOW_HEIGHT - 100) {
      param2 = _vr.y1 - this.FWP.WINDOW_HEIGHT - 100 - this.position_y;
    }
    return [param1, param2];
  }

  /**
   * PORT (wide screens): the battle HUD at the top the current worm's sprite (FWP.hud_focus) would lie under, with the
   * camera moved by (param1, param2) (FWP.camera_keep_top, 8 CSS px of room around them); none without the wide HUD.
   */
  hud_hits(param1: number, param2: number): any[] {
    const _keep: any[] = this.FWP.camera_keep_top();
    const _f: any = _keep.length ? this.FWP.hud_focus() : null;
    if (!_f) {
      return [];
    }
    const _st: any = this.FWP.stage;
    const _gap: number = 8 / (_st && _st.cssScale > 0 ? _st.cssScale : 1);
    const _x: number = _f.x + param1;
    const _y: number = _f.y + param2;
    return _keep.filter((k: any) => _x < k.x + k.width + _gap && k.x - _gap < _x + _f.width && _y < k.y + k.height + _gap && k.y - _gap < _y + _f.height);
  }

  /** PORT (wide screens): the current worm's sprite would lie under the battle HUD at the top (hud_hits). */
  hud_over_worm(param1: number, param2: number): boolean {
    return this.hud_hits(param1, param2).length > 0;
  }

  /**
   * PORT (wide screens): the camera's displacement (param1, param2) of check_displace changed, where the current worm's
   * sprite would lie under the battle HUD at the top, to the least move (down, left or right) of the camera within its
   * reach (camera_clamp) that shows it clear of every such group, without taking the worm further out of the bounds
   * check_displace keeps it in (x0..x1: the touch controls' room at the sides; the view's bottom less DISPLACE_LIMIT);
   * unchanged where there is none (the groups fade over it then). Presentation only.
   */
  clear_of_hud(param1: number, param2: number, x0: number, x1: number, vr: any): any {
    const _base: number[] = this.camera_clamp(param1, param2);
    const _hits: any[] = this.hud_hits(_base[0], _base[1]);
    const _f: any = this.FWP.hud_focus();
    if (!_hits.length || !_f) {
      return { x: param1, y: param2 };
    }
    const _st: any = this.FWP.stage;
    const _gap: number = 8 / (_st && _st.cssScale > 0 ? _st.cssScale : 1) + 1;
    const _o: any = this.FWP._obj[this.worms[this.cur_worm].fid];
    const _fx: number = _f.x + _base[0];
    const _fy: number = _f.y + _base[1];
    const _out = (dx: number, dy: number): number => {
      const _ox: number = _o.x + this.position_x + dx;
      const _oy: number = _o.y + this.position_y + dy;
      return Math.max(0, x0 - _ox, _ox - x1) + Math.max(0, _oy - (vr.y1 - this.DISPLACE_LIMIT));
    };
    const _was: number = _out(_base[0], _base[1]);
    const _tries: number[][] = [
      [_base[0], _base[1] + Math.max(..._hits.map((k: any) => k.y + k.height + _gap - _fy))],
      [_base[0] + Math.min(..._hits.map((k: any) => k.x - _gap - (_fx + _f.width))), _base[1]],
      [_base[0] + Math.max(..._hits.map((k: any) => k.x + k.width + _gap - _fx)), _base[1]],
    ];
    _tries.sort((a: number[], b: number[]) => Math.abs(a[0] - _base[0]) + Math.abs(a[1] - _base[1]) - (Math.abs(b[0] - _base[0]) + Math.abs(b[1] - _base[1])));
    for (const _t of _tries) {
      const _c: number[] = this.camera_clamp(_t[0], _t[1]);
      if (this.hud_over_worm(_c[0], _c[1]) || _out(_c[0], _c[1]) > _was + 0.5) {
        continue;
      }
      return { x: _c[0], y: _c[1] };
    }
    return { x: param1, y: param2 };
  }

  /**
   * PORT (touch screens): the camera at the battle's start: of its places left and right within its reach (camera_clamp)
   * that keep the current worm on the screen and clear of the touch controls' clusters (FWP.touch_zones) and the battle
   * HUD at the top (FWP.camera_keep_top), the one that leaves the fewest of the other worms under them or off the
   * screen, the nearest of equals: the enemy is seen at the start, not hidden under the fire button. Presentation only.
   */
  frame_worms(): void {
    const _zf: any = this.FWP.touch_zones;
    let _zones: any[] = [];
    try {
      _zones = typeof _zf == "function" ? _zf() || [] : [];
    } catch {
      _zones = [];
    }
    if (!_zones.length || !this.cur_worm) {
      return;
    }
    const _st: any = this.FWP.stage;
    const _gap: number = 8 / (_st && _st.cssScale > 0 ? _st.cssScale : 1);
    const _cover: any[] = _zones.concat(this.FWP.camera_keep_top());
    const _vr: any = this.FWP.view_rect();
    const _cur: any = this.FWP._obj[this.worms[this.cur_worm].fid];
    const _worms: any[] = [];
    for (let _i: number = 1; _i <= this.worms[0]; _i++) {
      const _w: any = this.worms[_i];
      const _o: any = _w && _w.state == "ok" ? this.FWP._obj[_w.fid] : null;
      const _s: any = _o && _o.sprite;
      if (!_s || !_s.stage || !_s.visible) {
        continue;
      }
      const _b: any = this.FWP.worm_rect(_s);
      if (_b) {
        _worms.push({ cur: _o === _cur, x: _b.x, y: _b.y, width: _b.width, height: _b.height });
      }
    }
    const _hidden = (r: any, dx: number): boolean => {
      const _x: number = r.x + dx;
      if (_x < _vr.x0 || _x + r.width > _vr.x1 || r.y < _vr.y0 || r.y + r.height > _vr.y1) {
        return true;
      }
      return _cover.some((k: any) => _x < k.x + k.width + _gap && k.x - _gap < _x + r.width && r.y < k.y + k.height + _gap && k.y - _gap < r.y + r.height);
    };
    const _cost = (dx: number): number => {
      let _n: number = 0;
      for (const _w of _worms) {
        if (_hidden(_w, dx)) {
          _n += _w.cur ? 1000 : 1;
        }
      }
      return _n;
    };
    let _best: number = 0;
    let _bestCost: number = _cost(0);
    if (_bestCost == 0) {
      return;
    }
    for (let _d: number = 8; _d <= _vr.x1 - _vr.x0; _d += 8) {
      for (const _s of [-_d, _d]) {
        const _c: number = this.camera_clamp(_s, 0)[0];
        const _k: number = _cost(_c);
        if (_k < _bestCost) {
          _best = _c;
          _bestCost = _k;
        }
      }
    }
    if (_best != 0 && _bestCost < 1000) {
      this.game_displace(_best, 0);
    }
  }

  generate_wind(): any {
    let _loc1_: any = 0;
    this.W = this.FWP.pseudo_random(-10, 10);
    if (this.cur_worm != 0) {
      this.W += Math.round((this.FWP._world.map_bitmap.width / 2 - this.FWP._obj[this.worms[this.cur_worm].fid].x) / 150);
    }
    if (this.mod(this.W) > 10) {
      this.W = 10 * this.sign(this.W);
    }
    switch (this.mod(this.W)) {
      case 0:
        this.W = 0;
        _loc1_ = 0;
        break;
      case 1:
        this.W = this.G * 0.119 * this.sign(this.W);
        _loc1_ = 7 * this.sign(this.W);
        break;
      case 2:
        this.W = this.G * 0.238 * this.sign(this.W);
        _loc1_ = 14 * this.sign(this.W);
        break;
      case 3:
        this.W = this.G * 0.357 * this.sign(this.W);
        _loc1_ = 22 * this.sign(this.W);
        break;
      case 4:
        this.W = this.G * 0.476 * this.sign(this.W);
        _loc1_ = 29 * this.sign(this.W);
        break;
      case 5:
        this.W = this.G * 0.595 * this.sign(this.W);
        _loc1_ = 37 * this.sign(this.W);
        break;
      case 6:
        this.W = this.G * 0.714 * this.sign(this.W);
        _loc1_ = 45 * this.sign(this.W);
        break;
      case 7:
        this.W = this.G * 0.833 * this.sign(this.W);
        _loc1_ = 52 * this.sign(this.W);
        break;
      case 8:
        this.W = this.G * 0.952 * this.sign(this.W);
        _loc1_ = 60 * this.sign(this.W);
        break;
      case 9:
        this.W = this.G * 1.071 * this.sign(this.W);
        _loc1_ = 67 * this.sign(this.W);
        break;
      case 10:
        this.W = this.G * 1.19 * this.sign(this.W);
        _loc1_ = 75 * this.sign(this.W);
    }
    this.FWP._interf.WindBar.wind_red_mask.width = _loc1_ > 0 ? _loc1_ : 0;
    this.FWP._interf.WindBar.wind_blue_mask.width = _loc1_ < 0 ? -_loc1_ : 0;
  }

  open_wpsheet(): any {
    let _loc1_: any = undefined;
    // PORT: a battle replayed from a command log (ScriptedInput) takes no interface input, like REPLAY.
    if (Boolean(this.FWP.REPLAY) || Boolean(this.mousecontrol) || Boolean(this.battle_input && !this.battle_input.interactive)) {
      return;
    }
    this.call_open_wpsheet = false;
    if (this.wpsheet) {
      this.close_wpsheet(0);
      return;
    }
    if (this.cur_worm != 0) {
    }
    if (this.cur_worm != 0) {
      if (Boolean(this.game_control) && this.worms[this.cur_worm].state == "ok") {
        _loc1_ = this.FWP._obj[this.worms[this.cur_worm].fid];
        if (Boolean(_loc1_.states.firecontrol && _loc1_.states.flying == 0 && !_loc1_.ai) && Boolean(_loc1_.weapon.shots_total == 0) && _loc1_.states.special == "") {
          this.wpsheet = true;
          // PORT: an online battle is not paused by the sheet (menus_freeze, BattleInputSource.freezesMenus).
          this.GAME_FREEZE = this.menus_freeze();
          this.FWP._interf.init_weapon_sheet(this._play_type);
        }
      }
    }
  }

  // PORT: the weapon sheet and the scanner pause the battle while they are open, except in an online battle: its turn
  // PORT: clock runs for every participant (BattleInput.freezesMenus, runtime/battle-input.ts, which also checks a
  // PORT: choice made while the ticks went on).
  menus_freeze(): boolean {
    return !(this.battle_input && this.battle_input.freezesMenus === false);
  }

  // PORT: the battle's own screen ("game"). The original wrote the timer and the status line to the screen on top, which
  // PORT: during a tick always was the battle screen (the weapon sheet and the scanner froze the ticks); an online
  // PORT: battle runs on under them (menus_freeze), so the battle screen is looked up. Without one: the top screen.
  game_link(): any {
    const i: any = this.FWP._interf;
    for (let k: number = i.cur_screen[0]; k >= 1; k--) {
      if (i.cur_screen[k] && i.cur_screen[k].name == "game") {
        return i.cur_screen[k].link;
      }
    }
    return i.cur_screen[i.cur_screen[0]].link;
  }

  close_wpsheet(param1: number, param2: number = 1): any {
    param1 = Number(param1);
    param2 = Number(param2);
    this.FWP._interf.last_call_game_mode = "";
    this.FWP._interf.remove();
    this.wpsheet = false;
    if (param1 != 0) {
      this.call_weapon.call = true;
      this.call_weapon.id = param1;
      this.call_weapon.range = param2;
    }
    this.GAME_FREEZE = false;
    this.FWP.stage_focus();
  }

  cancel_fight(): any {
    // PORT: a battle replayed from a command log (ScriptedInput) takes no interface input, no surrender either.
    if (this.battle_input && !this.FWP.REPLAY && !this.battle_input.interactive) {
      return;
    }
    // PORT: the surrender is input of the battle (recorded before the battle ends).
    if (this.battle_input && !this.FWP.REPLAY) {
      this.battle_input.surrender(this);
    }
    this.FWP.end_game_fn(0);
  }

  check_mousecontrol(): any {
    let _loc1_: any = undefined;
    let _loc2_: any = undefined;
    if (!this.FWP.REPLAY) {
      this.FWP._interf.CursorClip.x = this.mouseX;
      this.FWP._interf.CursorClip.y = this.mouseY < 610 ? this.mouseY : 610;
      this.FWP._interf.GirderClip.x = this.FWP._interf.CursorClip.x;
      this.FWP._interf.GirderClip.y = this.FWP._interf.CursorClip.y;
      // PORT (touch screens): no cursor or girder before the finger chose a point (FWP.touch_target_pending). Drawing only.
      const _pending: boolean = typeof this.FWP.touch_target_pending == "function" && this.FWP.touch_target_pending();
      this.FWP._interf.CursorClip.alpha = _pending ? 0 : 1;
      this.FWP._interf.GirderClip.alpha = _pending ? 0 : 1;
    }
    _loc1_ = "";
    if (this.FWP.REPLAY) {
      _loc2_ = this.read_key_press(this.timer);
      _loc1_ = _loc2_.other;
    } else {
      _loc1_ = this.battle_input ? this.battle_input.read_key() : this.FWP.KEY_PRESSED;
    }
    if (this.FWP._obj[this.worms[this.cur_worm].fid].weapon_name == "girder" || this.FWP._obj[this.worms[this.cur_worm].fid].weapon_name == "girder_pack") {
      if (this.girder_key_delay != 0) {
        --this.girder_key_delay;
      }
      if (this.girder_key_delay == 0) {
        if (_loc1_ == "left" || _loc1_ == "down") {
          ++this.girder_id;
          if (this.girder_id > 16) {
            this.girder_id = 1;
          }
          if (!this.FWP.REPLAY) {
            this.FWP._interf.modify_girder_cursor(this.girder_id);
          }
          this.girder_key_delay = 10;
        }
        if (_loc1_ == "right" || _loc1_ == "up") {
          --this.girder_id;
          if (this.girder_id < 1) {
            this.girder_id = 16;
          }
          if (!this.FWP.REPLAY) {
            this.FWP._interf.modify_girder_cursor(this.girder_id);
          }
          this.girder_key_delay = 10;
        }
      }
    }
    if (this.FWP._obj[this.worms[this.cur_worm].fid].weapon_flags.SPECIAL == "air_strike") {
      if (_loc1_ == "left") {
        this.strike_dir = "from left";
        if (!this.FWP.REPLAY) {
          this.FWP._interf.modify_cursor(this.strike_dir);
        }
      }
      if (_loc1_ == "right") {
        this.strike_dir = "from right";
        if (!this.FWP.REPLAY) {
          this.FWP._interf.modify_cursor(this.strike_dir);
        }
      }
    }
  }

  set_mousecontrol(): any {
    this.mousecontrol = true;
    if (this.FWP.REPLAY) {
      return;
    }
    this.FWP._interf.show_cursor("cursor");
    if (this.FWP._obj[this.worms[this.cur_worm].fid].weapon_name == "girder" || this.FWP._obj[this.worms[this.cur_worm].fid].weapon_name == "girder_pack") {
      this.FWP._interf.show_cursor("girder");
      this.FWP._interf.modify_girder_cursor(this.girder_id);
    }
    if (this.FWP._obj[this.worms[this.cur_worm].fid].weapon_flags.SPECIAL == "air_strike") {
      this.FWP._interf.modify_cursor(this.strike_dir);
    }
  }

  double_clicked(): any {
    if (!this.mousecontrol || Boolean(this.FWP.REPLAY) || Boolean(this.battle_input && !this.battle_input.interactive)) {
      return;
    }
    this.call_click.call = true;
    this.call_click.x = this.mouseX - this.position_x;
    this.call_click.y = this.mouseY - this.position_y;
  }

  proceed_mousecontrol(): any {
    let _loc1_: any = undefined;
    let _loc2_: any = undefined;
    let _loc3_: any = undefined;
    let _loc4_: any = undefined;
    let _loc5_: any = undefined;
    let _loc6_: any = undefined;
    let _loc7_: any = undefined;
    let _loc8_: any = undefined;
    let _loc9_: any = undefined;
    let _loc10_: any = undefined;
    let _loc11_: any = undefined;
    if (!this.mousecontrol) {
      return;
    }
    _loc1_ = this.call_click.x;
    _loc2_ = this.call_click.y;
    if (this.FWP._obj[this.worms[this.cur_worm].fid].weapon_name == "teleport" || this.FWP._obj[this.worms[this.cur_worm].fid].weapon_name == "upg_teleport" || this.FWP._obj[this.worms[this.cur_worm].fid].weapon_name == "upg_teleport2") {
      if (Boolean(this.check_teleport(_loc1_, _loc2_)) || this.FWP._obj[this.worms[this.cur_worm].fid].weapon_name == "upg_teleport2") {
        this.remove_mousecontrol();
        this.FWP._obj[this.worms[this.cur_worm].fid].vars.teleport_dest = { "x": _loc1_, "y": _loc2_ };
        this.FWP._obj[this.worms[this.cur_worm].fid].worm_fire();
        if (this.FWP._obj[this.worms[this.cur_worm].fid].weapon_name == "upg_teleport2") {
          this.make_object("P", "worm_explode", "", {
            "x": _loc1_,
            "y": _loc2_,
            "vx": 0,
            "vy": 0,
            "dmg_mult": 1
          });
        }
      }
    }
    if (this.FWP._obj[this.worms[this.cur_worm].fid].weapon_name == "girder" || this.FWP._obj[this.worms[this.cur_worm].fid].weapon_name == "girder_pack") {
      if (this.check_girder(this.girder_id, _loc1_, _loc2_)) {
        this.FWP._obj[this.worms[this.cur_worm].fid].worm_fire();
        if (Boolean(this.FWP._obj[this.worms[this.cur_worm].fid].weapon_flags.MULTIPLESHOT) && Boolean(this.FWP._obj[this.worms[this.cur_worm].fid].weapon.shots_remain == 0) || !this.FWP._obj[this.worms[this.cur_worm].fid].weapon_flags.MULTIPLESHOT) {
          this.remove_mousecontrol();
        }
        if ((this._play_type == "boss" || this._play_type == "assault") && Boolean(this.ag_animation.visible)) {
          this.FWP._world.explode(this.ag_animation.x, this.ag_animation.y, 200);
        }
      }
    }
    if (this.FWP._obj[this.worms[this.cur_worm].fid].weapon_flags.SPECIAL == "air_strike") {
      _loc3_ = 0;
      _loc4_ = -200;
      _loc5_ = 0;
      _loc6_ = 30;
      if (this.FWP._obj[this.worms[this.cur_worm].fid].weapon_flags.wid == "orbit_strike") {
        _loc5_ = 7;
        _loc4_ = -149;
        _loc6_ = 50;
      }
      this.remove_mousecontrol();
      this.FWP._obj[this.worms[this.cur_worm].fid].worm_fire();
      if (!this.FWP._obj[this.worms[this.cur_worm].fid].cur_shot_fail) {
        if (this.FWP._obj[this.worms[this.cur_worm].fid].weapon_flags.wid != "napalm_strike") {
          while (_loc4_ < _loc2_) {
            if (this.FWP._obj[this.worms[this.cur_worm].fid].weapon_flags.wid != "orbit_strike") {
              _loc5_ += this.G;
            }
            _loc4_ += _loc5_;
            _loc3_ += this.strike_dir == "from left" ? 6 : -6;
          }
          _loc8_ = this.FWP._obj[this.worms[this.cur_worm].fid].weapon_flags.STRIKEAMOUNT;
          _loc9_ = Math.ceil(_loc8_ / 2);
          _loc7_ = 1;
          while (_loc7_ <= _loc8_) {
            _loc10_ = "P";
            _loc11_ = false;
            if (this.FWP._obj[this.worms[this.cur_worm].fid].weapon_flags.wid == "mine_strike") {
              _loc10_ = "M";
              _loc11_ = true;
            }
            this.make_object(_loc10_, this.FWP._obj[this.worms[this.cur_worm].fid].weapon_flags.wid, "", {
              "x": _loc1_ - _loc3_ + _loc6_ * (_loc7_ - _loc9_),
              "y": (this.FWP._obj[this.worms[this.cur_worm].fid].weapon_flags.wid == "orbit_strike" ? -149 : -200),
              "vx": (this.strike_dir == "from left" ? 6 : -6) * (this.FWP._obj[this.worms[this.cur_worm].fid].weapon_flags.wid == "orbit_strike" ? 6 : 1),
              "vy": (this.FWP._obj[this.worms[this.cur_worm].fid].weapon_flags.wid == "orbit_strike" ? 7 * 6 : 0),
              "dmg_mult": this.FWP._obj[this.worms[this.cur_worm].fid].dmg_mult,
              "no_alert_delay": _loc11_
            });
            _loc7_++;
          }
        } else {
          this.fire_on_map = true;
          _loc7_ = 1;
          while (_loc7_ <= 30) {
            this.make_object("F", "fire", "", {
              "x": _loc1_ + 5 * (_loc7_ - 15),
              "y": -149,
              "vx": 0,
              "vy": 0,
              "timeout": 16000,
              "dmg_mult": this.FWP._obj[this.worms[this.cur_worm].fid].dmg_mult
            });
            _loc7_++;
          }
        }
      }
    }
  }

  remove_mousecontrol(): any {
    this.mousecontrol = false;
    if (this.FWP.REPLAY) {
      return;
    }
    this.FWP._interf.hide_cursor("cursor");
    if (this.FWP._obj[this.worms[this.cur_worm].fid].weapon_name == "girder" || this.FWP._obj[this.worms[this.cur_worm].fid].weapon_name == "girder_pack") {
      this.FWP._interf.hide_cursor("girder");
    }
  }

  generate_crate(param1: number, param2: any): any {
    param1 = Number(param1);
    param2 = as3.str(param2);
    ++this.CRATES_ON_MAP;
    this.make_object("C", "crate", "", {
      "x": param1,
      "y": -200,
      "vx": 0,
      "vy": 0,
      "crate_weapon": param2
    });
  }

  apply_worms_alpha(): any {
  }

  check_teleport(param1: number, param2: number): any {
    param1 = Number(param1);
    param2 = Number(param2);
    let _loc4_: any = undefined;
    let _loc3_: any = -3;
    loop0: while (_loc3_ <= 3) {
      _loc4_ = -9;
      while (true) {
        if (_loc4_ > 9) {
          _loc3_++;
          continue loop0;
        }
        if (this.FWP._world.is_land(param1 + _loc3_, param2 + _loc4_)) {
          break;
        }
        _loc4_++;
      }
      return false;
    }
    return true;
  }

  check_girder(param1: number, param2: number, param3: number, param4: boolean = false): any {
    param1 = Number(param1);
    param2 = Number(param2);
    param3 = Number(param3);
    param4 = Boolean(param4);
    let _loc5_: any = undefined;
    let _loc6_: any = undefined;
    let _loc7_: any = undefined;
    let _loc8_: any = undefined;
    let _loc9_: any = undefined;
    let _loc10_: any = undefined;
    if (!param4) {
      _loc8_ = 250;
      if (this.FWP.player.perks["engineer"]) {
        _loc8_ = this.FWP.get_perk_effect("engineer", this.FWP.player.perks.engineer, "");
      }
      if (Math.sqrt(Math.pow(param2 - this.FWP._obj[this.worms[this.cur_worm].fid].x, 2) + Math.pow(param3 - this.FWP._obj[this.worms[this.cur_worm].fid].y, 2)) > _loc8_) {
        return;
      }
      if (param1 == 1 && (param2 < 10 || param2 > this.FWP._world.map_bitmap.width - 10 || param3 < 70 || param3 > 650 - 18 - 70)) {
        return false;
      }
      if ((param1 == 2 || param1 == 8) && (param2 < 36 || param2 > this.FWP._world.map_bitmap.width - 36 || param3 < 69 || param3 > 650 - 18 - 69)) {
        return false;
      }
      if ((param1 == 3 || param1 == 7) && (param2 < 57 || param2 > this.FWP._world.map_bitmap.width - 57 || param3 < 57 || param3 > 650 - 18 - 57)) {
        return false;
      }
      if ((param1 == 4 || param1 == 6) && (param2 < 69 || param2 > this.FWP._world.map_bitmap.width - 69 || param3 < 36 || param3 > 650 - 18 - 36)) {
        return false;
      }
      if (param1 == 5 && (param2 < 70 || param2 > this.FWP._world.map_bitmap.width - 70 || param3 < 10 || param3 > 650 - 18 - 10)) {
        return false;
      }
      if (param1 == 9 && (param2 < 10 || param2 > this.FWP._world.map_bitmap.width - 10 || param3 < 35 || param3 > 650 - 18 - 35)) {
        return false;
      }
      if ((param1 == 10 || param1 == 16) && (param2 < 22 || param2 > this.FWP._world.map_bitmap.width - 22 || param3 < 36 || param3 > 650 - 18 - 36)) {
        return false;
      }
      if ((param1 == 11 || param1 == 15) && (param2 < 32 || param2 > this.FWP._world.map_bitmap.width - 32 || param3 < 32 || param3 > 650 - 18 - 32)) {
        return false;
      }
      if ((param1 == 12 || param1 == 14) && (param2 < 36 || param2 > this.FWP._world.map_bitmap.width - 36 || param3 < 22 || param3 > 650 - 18 - 22)) {
        return false;
      }
      if (param1 == 13 && (param2 < 35 || param2 > this.FWP._world.map_bitmap.width - 35 || param3 < 10 || param3 > 650 - 18 - 10)) {
        return false;
      }
    }
    param2 -= Math.round(this.FWP._interf["girder" + param1 + "map"].width / 2);
    param3 -= Math.round(this.FWP._interf["girder" + param1 + "map"].height / 2);
    _loc5_ = new BitmapData(this.FWP._world.map_bitmap.width, this.FWP._world.map_bitmap.height, false, 0);
    _loc6_ = 1;
    while (_loc6_ <= this.OBJ[0]) {
      if (!this.OBJ[_loc6_].free && (this.OBJ[_loc6_].model == "W" || this.OBJ[_loc6_].model == "Z")) {
        _loc9_ = -4;
        while (_loc9_ <= 4) {
          _loc10_ = -9;
          while (_loc10_ <= 9) {
            _loc5_.setPixel32(Math.round(this.FWP._obj[this.OBJ[_loc6_].fid].x + _loc9_), Math.round(this.FWP._obj[this.OBJ[_loc6_].fid].y + _loc10_), 4294967295);
            _loc10_++;
          }
          _loc9_++;
        }
      }
      _loc6_++;
    }
    _loc6_ = 0;
    loop1: while (_loc6_ <= this.FWP._interf["girder" + param1 + "map"].width) {
      _loc9_ = 0;
      while (true) {
        if (_loc9_ > this.FWP._interf["girder" + param1 + "map"].height) {
          _loc6_++;
          continue loop1;
        }
        if (this.FWP._interf["girder" + param1 + "map"].getPixel(_loc6_, _loc9_).toString(16) != "0" && (this.FWP._world.map_bitmap.getPixel(param2 + _loc6_, param3 + _loc9_).toString(16) != "0" || _loc5_.getPixel(param2 + _loc6_, param3 + _loc9_).toString(16) != "0")) {
          break;
        }
        _loc9_++;
      }
      return false;
    }
    _loc7_ = this.FWP._interf["girder" + param1 + "map"];
    this.FWP._world.map_bitmap.copyPixels(_loc7_, new Rectangle(0, 0, this.FWP._interf["girder" + param1 + "map"].width, this.FWP._interf["girder" + param1 + "map"].height), new Point(param2, param3), _loc7_, new Point(0, 0), true);
    _loc5_.dispose();
    return true;
  }

  remove_fire(): any {
    if (!this.fire_on_map) {
      return;
    }
    this.fire_on_map = false;
    this.FWP._world.FireMap.fillRect(new Rectangle(0, 0, this.FWP._world.map_bitmap.width, this.FWP._world.map_bitmap.height), 0);
  }

  survival_replace(param1: number, param2: any = "std"): any {
    param1 = Number(param1);
    param2 = as3.str(param2);
    let _loc4_: any = undefined;
    let _loc5_: any = undefined;
    let _loc6_: any = undefined;
    let _loc3_: any = this.FWP._obj[this.worms[param1].fid];
    if (param2 == "std") {
      ++this.SURV_KILLS;
      this.add_status("Убито червей: " + this.SURV_KILLS + "/" + this.FWP.TEAMS_DEF["survival" + this._play_id].kills + ".");
      if (this.SURV_KILLS == this.FWP.TEAMS_DEF["survival" + this._play_id].kills) {
        this.add_status("Черви больше не будут появляться.");
      }
      _loc3_.vars.health = Math.ceil(this.FWP.TEAMS_DEF["survival" + this._play_id]["team" + _loc3_.wteam]["worm1"].health * this.FWP.get_skill_multi("health"));
    }
    _loc4_ = 0;
    do {
      _loc5_ = this.FWP.pseudo_random(1, this.FWP._world.map_bitmap.width);
      _loc6_ = this.FWP.pseudo_random(50, this.FWP._world.map_bitmap.height - 50);
    } while (!(Boolean(this.check_teleport(_loc5_, _loc6_)) && Boolean(this.check_girder(13, _loc5_, _loc6_ + 18, true))));
    _loc3_.vars.vx = 0;
    _loc3_.vars.vy = 0;
    // PORT: deliberate fix of a hang the original has too (proc.as:2934-2936): the worm moved to its new spot kept
    // PORT: its sliding speed vs. A worm pushed into a slide by a blast and thrown off the map by a second one before
    // PORT: the slide ended (in flight worm_modify_flying clears `sliding` but not vs; only a landing that starts a
    // PORT: new slide, obj.collision, replaces it) arrives here with the old vs, lands without sliding and stays
    // PORT: unready for good: obj.check_resting waits for vs == 0, which only obj.sliding brings. The new spot has
    // PORT: nothing to do with the old slide, so the drop starts from rest, like vx / vy.
    _loc3_.vars.vs = 0;
    _loc3_.clear_flags();
    _loc3_.worm_modify_health();
    _loc3_.x = _loc5_;
    _loc3_.y = _loc6_;
    _loc3_.death = false;
    _loc3_.vars.special_timeout = 0;
    _loc3_.states.flying = 1;
    _loc3_.sprite.worm_namebox.visible = true;
    _loc3_.sprite.worm_hpbox.visible = true;
    _loc3_.sprite.worm_name.visible = true;
    _loc3_.sprite.worm_hp.visible = true;
    this.make_object("P", "null_explode", "", {
      "x": _loc5_,
      "y": _loc6_,
      "vx": 0,
      "vy": 0,
      "dmg_mult": 1
    });
    this.make_object("P", "null_explode", "", {
      "x": _loc5_,
      "y": _loc6_ + 18,
      "vx": 0,
      "vy": 0,
      "dmg_mult": 1
    });
  }

  catch_bug(): any {
  }

  add_status(param1: any): any {
    param1 = as3.str(param1);
    let _loc2_: any = undefined;
    let _loc3_: any = undefined;
    let _loc4_: any = undefined;
    if (this.STATUS_TEXT[0] >= this.STATUS_MAX) {
      _loc4_ = 1;
      while (_loc4_ <= this.STATUS_MAX - 1) {
        this.STATUS_TEXT[_loc4_] = this.STATUS_TEXT[_loc4_ + 1];
        _loc4_++;
      }
      this.STATUS_TEXT[this.STATUS_MAX] = param1;
    } else {
      ++this.STATUS_TEXT[0];
      this.STATUS_TEXT[this.STATUS_TEXT[0]] = param1;
    }
    _loc2_ = "";
    _loc3_ = 1;
    while (_loc3_ <= this.STATUS_TEXT[0]) {
      _loc2_ += this.STATUS_TEXT[_loc3_] + "\n";
      _loc3_++;
    }
    this.game_link().status_text.text = _loc2_;
  }

  hide_ag_effect(): any {
    this.ag_animation.visible = false;
  }

  write_key_press(param1: any): any {
    let _loc2_: any = this.FWP.get_char_from_key(param1);
    if (param1.other == "weapon") {
      this.append_replay_text(this.timer, _loc2_, 0, this.call_weapon);
      this.key_last = "";
      return;
    }
    if (param1.other == "click") {
      this.append_replay_text(this.timer, _loc2_, 0, this.call_click);
      this.key_last = "";
      return;
    }
    if (this.key_last != "") {
      if (this.key_last == _loc2_) {
        ++this.key_duration;
      } else {
        this.append_replay_text(this.key_iter, this.key_last, this.key_duration, {});
        this.key_last = _loc2_;
        this.key_duration = 0;
        this.key_iter = this.timer;
      }
    } else if (_loc2_ != "") {
      this.key_last = _loc2_;
      this.key_duration = 0;
      this.key_iter = this.timer;
    }
  }

  append_replay_text(param1: number, param2: any, param3: number, param4: any): any {
    param1 = Number(param1);
    param2 = as3.str(param2);
    param3 = Number(param3);
    this.ROUNDS_RECORD += this.FWP.encode_replay_number(param1) + "&" + param2;
    if (param3 != 0) {
      this.ROUNDS_RECORD += "%";
      this.ROUNDS_RECORD += this.FWP.encode_replay_number(param3);
    }
    if (param2 == "S") {
      this.ROUNDS_RECORD += "%" + this.FWP.encode_replay_number(param4.id) + "%" + this.FWP.encode_replay_number(param4.range);
    }
    if (param2 == "T") {
      this.ROUNDS_RECORD += "%" + this.FWP.encode_replay_number(param4.x) + "%" + this.FWP.encode_replay_number(param4.y);
    }
    this.ROUNDS_RECORD += "$";
  }

  append_replay_param(param1: any, param2: any): any {
    param1 = as3.str(param1);
    let _loc3_: any = undefined;
    let _loc4_: any = undefined;
    let _loc5_: any = undefined;
    if (param1 == "play_type") {
      if (param2 == "career") {
        this.PARAMS_RECORD += "DEc$";
      }
      if (param2 == "missions") {
        this.PARAMS_RECORD += "DEm$";
      }
      if (param2 == "survival") {
        this.PARAMS_RECORD += "DEs$";
      }
      if (param2 == "boss") {
        this.PARAMS_RECORD += "DEb$";
      }
    }
    if (param1 == "play_id") {
      this.PARAMS_RECORD += "I" + this.FWP.encode_replay_number(param2) + "$";
    }
    if (param1 == "random") {
      this.PARAMS_RECORD += "R" + this.FWP.encode_replay_number(param2) + "$";
    }
    if (param1 == "player") {
      this.PARAMS_RECORD += "P";
      this.PARAMS_RECORD += this.FWP.encode_replay_number(param2.worm1.attack) + "$";
      this.PARAMS_RECORD += this.FWP.encode_replay_number(param2.worm1.protect) + "$";
      this.PARAMS_RECORD += this.FWP.encode_replay_number(param2.worm1.health) + "$";
      this.PARAMS_RECORD += this.FWP.encode_replay_number(param2.worm1.spec) + "$";
      this.PARAMS_RECORD += this.FWP.encode_replay_number(param2.worms) + "$";
      this.PARAMS_RECORD += this.FWP.encode_replay_number(this.FWP.player.tired) + "$";
      this.PARAMS_RECORD += "S";
      for (_loc3_ of as3.keys(param2.worm1.perks)) {
        _loc4_ = 0;
        for (_loc5_ of as3.keys(this.FWP.PERKS_DEF)) {
          if (_loc5_ == _loc3_) {
            _loc4_ = this.FWP.PERKS_DEF[_loc5_].id;
          }
        }
        this.PARAMS_RECORD += this.FWP.encode_replay_number(_loc4_) + "%" + this.FWP.encode_replay_number(param2.worm1.perks[_loc3_]) + "$";
      }
      // PORT: replay determinism. init_replay gives the replayed team 100 copies of every weapon, which is harmless
      // PORT: for weapons the recorded input selects, but "emg_teleport" is used by the engine itself when a worm
      // PORT: drowns (obj.check_coords, obj.as:1338-1345): the replay of a battle where the player had fewer copies
      // PORT: diverged at the first drowning. The team's own count is written as one more perk record with the
      // PORT: reserved id 0 (PERKS_DEF ids are 1..63): init_replay's perk lookup (FWP.as:15914-15928) ignores
      // PORT: unknown ids and every perk-list parser keeps the record, so the format stays compatible;
      // PORT: FWP.init_replay applies it.
      this.PARAMS_RECORD += this.FWP.encode_replay_number(0) + "%" + this.FWP.encode_replay_number(param2.weapons && param2.weapons["emg_teleport"] ? param2.weapons["emg_teleport"][1] : 0) + "$";
      this.PARAMS_RECORD += "Z";
      this.PARAMS_RECORD += this.FWP.encode_replay_number(this.FWP.player.settings.skill) + "$";
      this.PARAMS_RECORD += "X";
      this.PARAMS_RECORD += this.FWP.encode_replay_number(this.FWP.player.cur_impl) + "$";
    }
  }

  read_key_press(param1: number): any {
    param1 = Number(param1);
    let _loc2_: any = {
      "space": false,
      "other": "none",
      "weapon": 0,
      "range": 1,
      "click_x": 0,
      "click_y": 0
    };
    if (this.FWP.REPLAY_CUR_MOVE[param1]) {
      _loc2_.space = this.FWP.REPLAY_CUR_MOVE[param1].key_code.space;
      _loc2_.other = this.FWP.REPLAY_CUR_MOVE[param1].key_code.other;
      _loc2_.weapon = this.FWP.REPLAY_CUR_MOVE[param1].params.weapon;
      _loc2_.range = this.FWP.REPLAY_CUR_MOVE[param1].params.range;
      _loc2_.click_x = this.FWP.REPLAY_CUR_MOVE[param1].params.click_x;
      _loc2_.click_y = this.FWP.REPLAY_CUR_MOVE[param1].params.click_y;
      if (this.FWP.REPLAY_CUR_MOVE[param1].repeats != 0) {
        --this.FWP.REPLAY_CUR_MOVE[param1].repeats;
        this.FWP.REPLAY_CUR_MOVE[param1 + 1] = this.FWP.clone(this.FWP.REPLAY_CUR_MOVE[param1]);
        this.FWP.REPLAY_CUR_MOVE[param1] = undefined;
      }
    }
    return _loc2_;
  }

  mod(param1: number): number {
    param1 = Number(param1);
    return Math.abs(param1);
  }

  sign(param1: number): number {
    param1 = Number(param1);
    return param1 >= 0 ? 1 : -1;
  }

  game_get_color(param1: number): number {
    param1 = Number(param1);
    switch (param1) {
      case 1:
        return 16744319;
      case 2:
        return 10330111;
      case 3:
        return 8454016;
      case 4:
        return 16777088;
      case 5:
        return 8454143;
      case 6:
        return 16744703;
      case 7:
        return 15724527;
      default:
        return 16777215;
    }
  }

  game_get_tfwidth(param1: number): number {
    param1 = Number(param1);
    let _loc2_: any = 10 + param1 * 5;
    return _loc2_ % 2 == 0 ? _loc2_ - 1 : Number(_loc2_);
  }

  optim_obj(): any {
    let _loc3_: any = undefined;
    let _loc4_: any = undefined;
    let _loc1_: any = this.OBJ;
    let _loc2_: any = _loc1_[0];
    while (true) {
      _loc3_ = 0;
      _loc4_ = 1;
      while (_loc4_ <= _loc1_[0]) {
        if (_loc1_[_loc4_].free) {
          _loc3_ = _loc4_;
          break;
        }
        _loc4_++;
      }
      if (_loc3_ == 0) {
        break;
      }
      if (_loc3_ == _loc1_[0]) {
        --_loc1_[0];
        break;
      }
      _loc4_ = _loc3_;
      while (_loc4_ < _loc1_[0]) {
        _loc1_[_loc4_].fid = _loc1_[_loc4_ + 1].fid;
        _loc1_[_loc4_].model = _loc1_[_loc4_ + 1].model;
        _loc1_[_loc4_].free = _loc1_[_loc4_ + 1].free;
        _loc1_[_loc4_].ready = _loc1_[_loc4_ + 1].ready;
        if (this.FWP._obj[_loc1_[_loc4_ + 1].fid]) {
          this.FWP._obj[_loc1_[_loc4_ + 1].fid].pid = _loc4_;
        }
        _loc4_++;
      }
      --_loc1_[0];
    }
    _loc4_ = _loc1_[0] + 1;
    while (_loc4_ <= _loc2_) {
      _loc1_[_loc4_] = {};
      _loc4_++;
    }
  }
}
